<template>
  <div>
    <!-- #region NAVBAR   -->
    <nav class="bg-red-700">
      <ul class="nav-wrapper">
        <li v-if="assignmentData" class="icon" @click="handleGoBack">
          <a href="#">
            <span class="tooltip">Go Back</span>
            <span><i class="fa-solid fa-arrow-left text-white"> </i></span>
          </a>
        </li>

        <li class="icon">
          <RouterLink to="/">
            <span class="tooltip">Home</span>
            <span><i class="fa-solid fa-house text-white ml-3"> </i></span
          ></RouterLink>
        </li>

        <li>
          <a href="#">
            <div class="mx-3 text-base lg:text-2xl text-white">Assignments</div>
          </a>
        </li>

        <li>
          <a href="#">
            <div
              v-if="boardStyle === 'Board' && pages.length > 1"
              class="flex justify-between fnt-sm"
            >
              <button class="btn-icon" @click="handlePageUp">
                <i class="fa-solid fa-chevrons-up text-white"></i>
              </button>
              <div class="text-white">
                {{ `${pageNumber + 1} of ${pages.length}` }}
              </div>

              <button class="btn-icon" @click="handlePageDown">
                <i class="fa-solid fa-chevrons-down text-white"></i>
              </button>
            </div>
          </a>
        </li>

        <li v-if="user.securityGroup.keys.includes(103)">
          <a href="#">
            <input
              @click="[(search = ''), filterEmployeesSchedule()]"
              class="mx-3 text-align-center w-24 h-8 rounded-md border-gray-500"
              v-model="search"
              @input="filterEmployeesSchedule()"
              type="text"
              maxlength="6"
            />
          </a>
        </li>

        <li
          @click="handleOpenFilters"
          class="icon"
          v-if="user.securityGroup.keys.includes(103)"
        >
          <a href="#">
            <span class="tooltip">Employee Filters</span>
            <span><i class="fa-solid fa-bars-filter text-yellow-500"></i></span>
          </a>
        </li>

        <li
          class="icon"
          @click="handleShowWarnings"
          v-if="user.securityGroup.keys.includes(104)"
        >
          <a href="#">
            <span class="tooltip">{{ `Warnings ${warnings.length}` }}</span>
            <span
              ><i class="fa-solid fa-triangle-exclamation text-orange-500"></i
            ></span>
          </a>
        </li>

        <li
          v-if="assignmentData"
          @click="assignmentData.isVisible = !assignmentData.isVisible"
          class="icon"
        >
          <a href="#">
            <span class="tooltip">Toggle Assignment Shadow</span>
            <span><i class="fa-solid fa-square text-blue-500"></i></span>
          </a>
        </li>

        <li @click="handleToggleBoardStyle" class="icon">
          <a href="#">
            <span class="tooltip">Switch Board</span>
            <span><i class="fa-solid fa-bolt text-yellow-500"></i></span>
          </a>
        </li>
        <li
          @click="showSpecialAirportsDialog = true"
          class="icon"
          v-if="user.securityGroup.keys.includes(702)"
        >
          <a href="#">
            <span class="tooltip">Special Airports</span>
            <span><i class="fa-solid fa-tower-control text-red-500"></i></span>
          </a>
        </li>

        <li @click="zoomIn" class="icon" v-if="boardStyle !== 'List'">
          <a href="#">
            <span class="tooltip">Zoom In</span>
            <span><i class="fa-solid fa-magnifying-glass-plus"></i></span>
          </a>
        </li>
        <li @click="zoomOut" class="icon" v-if="boardStyle !== 'List'">
          <a href="#">
            <span class="tooltip">Zoom Out</span>
            <span><i class="fa-solid fa-magnifying-glass-minus"></i></span>
          </a>
        </li>

        <li @click="handleAdjustStationAssignments" class="icon">
          <a href="#">
            <span class="tooltip">Adjust Station Assignments</span>
            <span><i class="fa-solid fa-warehouse text-gray-400"></i></span>
          </a>
        </li>

        <li @click="getData" class="icon">
          <a href="#">
            <span class="tooltip">Refresh</span>
            <span><i class="fa-solid fa-rotate"></i></span>
          </a>
        </li>

        <li
          v-if="assignmentData"
          @click="handleToggleStationFilter"
          class="icon"
        >
          <a href="#">
            <span class="tooltip">Filter By Station </span>
            <span
              ><i
                class="fa-solid fa-location-dot text-white cursor-pointer ml-5"
                :style="getFilterByStationStyle()"
              ></i
            ></span>
          </a>
        </li>

        <li>
          <a>
            <div
              v-if="boardStyle === 'Board'"
              class="txt-sm text-white mr-5 cursor-default"
            >
              {{ `Employees: ${formatNumber(totalEmployees)}` }}
            </div>
            <div v-else class="txt-sm text-white mr-5 cursor-default">
              {{ `Assignments: ${formatNumber(assignmentsList.length)}` }}
            </div>
          </a>
        </li>
      </ul>
    </nav>

    <!-- #endregion -->

    <!-- #region WARNINGS -->
    <!-- SNACKBAR -->
    <RSnackbar
      v-if="snackbarVisible"
      :backgroundColor="snackbarColor"
      :message="snackbarText"
      :timeout="3000"
      @close="snackbarVisible = false"
    >
    </RSnackbar>

    <!-- ASSIGNMENT WARNINGS -->
    <r-modal
      v-if="showAssigmentWarningsModal"
      @close="handleCloseAssignmentWarningsModal(false)"
    >
      <div class="border-l-8 border-2 border-red-500 p-2">
        <!-- TITLE -->
        <div class="flex justify-between">
          <div class="text-2xl text-red-500">Assignment Warnings</div>
          <button
            @click="handleCloseAssignmentWarningsModal(false)"
            class="btn-icon"
          >
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>

        <div class="px-5">
          <div class="text-2xl text-blue-500 font-bold">
            {{ `${employee.surname}, ${employee.givenName}` }}
          </div>
          <div>
            {{
              `Warnings: ${hardWarnings.length} hard, ${
                assignmentWarnings.length - hardWarnings.length
              } soft.`
            }}
          </div>
        </div>

        <div
          class="warning-tile"
          :style="getWarningStyle(warning.level)"
          v-for="(warning, index) in assignmentWarnings"
          :key="index"
        >
          <div class="flex justify-between font-2xl font-bold">
            <div>
              {{ warning.type }}
            </div>
            <i
              v-if="warning.level === 'Hard'"
              class="fa-solid fa-octagon-exclamation text-red-500"
            ></i>
            <i v-else class="fa-solid fa-warning text-orange-500"></i>
          </div>

          <div class="text-sm">{{ warning.message }}</div>
        </div>
        <div class="text-sm color-gray my-2">
          {{
            `Training Records updated at: ${formatDateTime(
              this.employee.trainingRecords.updatedAt
            )} UTC`
          }}
        </div>

        <div v-if="hardWarnings.length">
          <div
            v-if="user.securityGroup.keys.includes(115)"
            class="flex justify-between px-4 py-2"
          >
            <div class="text-sm text-red-500">
              By clicking acknowledge, you confirm that you have read and
              understood these warnings.
            </div>
            <button
              @click="handleCloseAssignmentWarningsModal(true)"
              class="btn bg-blue-500 text-white"
            >
              Acknowledge
            </button>
          </div>
          <div v-else class="flex justify-between px-4 py-2">
            <div class="text-sm text-red-500">
              You do not have the required permission to continue.
            </div>
            <button
              @click="handleCloseAssignmentWarningsModal(false)"
              class="btn bg-gray-500 text-white"
            >
              Cancel
            </button>
          </div>
        </div>
        <div v-else class="flex justify-between px-4 py-2">
          <div class="text-sm text-red-500">
            By clicking acknowledge, you confirm that you have read and
            understood these warnings.
          </div>

          <button
            @click="handleCloseAssignmentWarningsModal(true)"
            class="btn bg-blue-500 text-white"
          >
            Acknowledge
          </button>
        </div>
      </div>
    </r-modal>

    <!-- COMPUTED WARNINGS -->
    <r-modal v-if="showWarningsDialog" @close="showWarningsDialog = false">
      <div class="border-l-8 border-2 border-red-500 p-2">
        <!-- TITLE -->
        <div class="px-3 flex justify-between">
          <div class="flex gap-1 text-2xl font-bolditems-center">
            <div class="mb-2">Warnings</div>
            <div>{{ `(${filteredWarnings.length})` }}</div>
          </div>

          <button @click="showWarningsDialog = false" class="btn-icon">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>

        <!-- Select Warning Type -->
        <div class="mb-3 px-2">
          <select
            v-model="selectedWarningType"
            class="block w-48 py-1.5 rounded-md border-0 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-blue-600 sm:text-sm sm:leading-6"
          >
            <option
              v-for="(type, index) in warningTypeOptions"
              :key="index"
              :value="type"
            >
              {{ type }}
            </option>
          </select>
        </div>

        <!-- WARNINGS -->

        <div class="max-h-[300px] lg:max-h-[500px] relative overflow-x-auto">
          <table
            v-if="filteredWarnings.length"
            class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400"
          >
            <thead
              class="text-xs text-gray-200 uppercase bg-gray-500 dark:bg-gray-700 dark:text-gray-400"
            >
              <tr>
                <th
                  style="width: 10%"
                  scope="col"
                  class="px-6 py-2 cursor-pointer"
                  @click="sortWarningsByKey('employeeName')"
                >
                  Employee
                </th>

                <th
                  style="width: 20%"
                  scope="col"
                  class="px-6 py-2 cursor-pointer"
                  @click="sortWarningsByKey('type')"
                >
                  Warning Type
                </th>

                <th
                  style="width: 15%"
                  scope="col"
                  class="px-6 py-2 cursor-pointer"
                  @click="sortWarningsByKey('assignmentType')"
                >
                  Assignment Type
                </th>
                <th
                  style="width: 10%"
                  scope="col"
                  class="px-6 py-2 cursor-pointer"
                  @click="sortWarningsByKey('level')"
                >
                  Level
                </th>
                <th
                  scope="col"
                  class="px-6 py-2 cursor-pointer"
                  @click="sortWarningsByKey('message')"
                >
                  Message
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="warning in filteredWarnings"
                :key="warning._id"
                class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
                @click="
                  handleShowAssignmentInformationDialogFromWarning(warning)
                "
              >
                <td
                  scope="row"
                  class="px-6 py-2 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                >
                  {{ warning.employee.surname }},
                  {{ warning.employee.givenName }}
                </td>
                <td class="px-6 py-2">{{ warning.type }}</td>
                <td class="px-6 py-2">
                  {{ warning.assignment.type }}
                </td>
                <td class="px-6 py-2">
                  {{ warning.level }}
                </td>

                <td class="px-6 py-2">
                  {{ warning.message }}
                </td>
              </tr>
            </tbody>
          </table>

          <div
            v-else
            class="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4"
            role="alert"
          >
            <p class="font-bold">No Warnings Found</p>
            <p>There are no warnings matching the selected filters.</p>
          </div>
        </div>
      </div>
    </r-modal>

    <!-- #endregion -->

    <!-- #region LOADING -->

    <r-spinner v-if="loading"> </r-spinner>
    <!-- #endregion -->

    <!-- #region DIALOGS -->
    <!--  FILTERS DIALOG -->
    <r-modal v-if="showFiltersDialog" @close="showFiltersDialog = false">
      <div class="p-5">
        <!-- Header -->
        <div class="flex justify-between mb-1">
          <div class="text-2xl font-bold ml-5">Employee Filters</div>
          <button @click="showFiltersDialog = false" class="btn-icon">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>

        <div
          class="flex flex-col justify-between text-sm px-3 max-h-[300px] lg:max-h-[500px] overflow-x-auto"
        >
          <!-- Section -->
          <div class="px-5">
            <!-- Filter by Aircraft Deck -->
            <div class="border-b border-gray-400 mb-5">
              <div class="flex h-6 items-center mb-2">
                <input
                  v-model="filterByAircraftDeck"
                  id="filterByAircraftDeck"
                  aria-describedby="filter-description"
                  name="filterByAircraftDeck"
                  type="checkbox"
                  class="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-600 cursor-pointer"
                />

                <div class="ml-3 text-base leading-6">
                  <label
                    for="filterByAircraftDeck"
                    class="font-medium text-gray-900"
                    >Filter by Aircraft Deck</label
                  >
                  {{ " " }}
                </div>
              </div>

              <div class="flex my-1 px-5 pb-2" v-if="filterByAircraftDeck">
                <Listbox as="div" v-model="selectedAircraftDeck" class="mb-10">
                  <ListboxLabel
                    class="block text-sm font-medium leading-6 text-gray-900"
                    >Show Employees when job title is associated
                    with</ListboxLabel
                  >
                  <div class="relative mt-2 min-w-[250px]">
                    <ListboxButton
                      class="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-600 sm:text-sm sm:leading-6"
                    >
                      <span class="block truncate">{{
                        selectedAircraftDeck
                      }}</span>
                      <span
                        class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2"
                      >
                        <ChevronUpDownIcon
                          class="h-5 w-5 text-gray-400"
                          aria-hidden="true"
                        />
                      </span>
                    </ListboxButton>

                    <transition
                      leave-active-class="transition ease-in duration-100"
                      leave-from-class="opacity-100"
                      leave-to-class="opacity-0"
                    >
                      <ListboxOptions
                        class="absolute z-10 mt-1 max-h-64 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                      >
                        <ListboxOption
                          as="template"
                          v-for="(option, id) in aircraftDeckOptions"
                          :key="id"
                          :value="option"
                          v-slot="{ active, selectedAircraftDeck }"
                        >
                          <li
                            :class="[
                              active
                                ? 'bg-blue-600 text-white'
                                : 'text-gray-900',
                              'relative cursor-default select-none py-2 pl-3 pr-9',
                            ]"
                          >
                            <span
                              :class="[
                                selectedAircraftDeck
                                  ? 'font-semibold'
                                  : 'font-normal',
                                'block truncate',
                              ]"
                              >{{ option }}</span
                            >

                            <span
                              v-if="selectedAircraftDeck"
                              :class="[
                                active ? 'text-white' : 'text-blue-600',
                                'absolute inset-y-0 right-0 flex items-center pr-4',
                              ]"
                            >
                              <CheckIcon class="h-5 w-5" aria-hidden="true" />
                            </span>
                          </li>
                        </ListboxOption>
                      </ListboxOptions>
                    </transition>
                  </div>
                </Listbox>
              </div>
            </div>

            <!-- Filter by Company Name -->
            <div class="border-b border-gray-400 mb-5">
              <div class="flex h-6 items-center mb-2">
                <input
                  v-model="filterByCompany"
                  id="filterByCompany"
                  aria-describedby="filter-description"
                  name="filterByCompany"
                  type="checkbox"
                  class="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-600 cursor-pointer"
                />

                <div class="ml-3 text-base leading-6">
                  <label for="filterByCompany" class="font-medium text-gray-900"
                    >Filter by Company</label
                  >
                  {{ " " }}
                </div>
              </div>

              <div class="flex my-1 px-5 pb-2" v-if="filterByCompany">
                <Listbox as="div" v-model="selectedCompany" class="mb-10">
                  <ListboxLabel
                    class="block text-sm font-medium leading-6 text-gray-900"
                    >Show Employees from this Company</ListboxLabel
                  >
                  <div class="relative mt-2 min-w-[250px]">
                    <ListboxButton
                      class="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-600 sm:text-sm sm:leading-6"
                    >
                      <span class="block truncate">{{ selectedCompany }}</span>
                      <span
                        class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2"
                      >
                        <ChevronUpDownIcon
                          class="h-5 w-5 text-gray-400"
                          aria-hidden="true"
                        />
                      </span>
                    </ListboxButton>

                    <transition
                      leave-active-class="transition ease-in duration-100"
                      leave-from-class="opacity-100"
                      leave-to-class="opacity-0"
                    >
                      <ListboxOptions
                        class="absolute z-10 mt-1 max-h-64 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                      >
                        <ListboxOption
                          as="template"
                          v-for="(option, id) in companyOptions"
                          :key="id"
                          :value="option"
                          v-slot="{ active, selectedCompany }"
                        >
                          <li
                            :class="[
                              active
                                ? 'bg-blue-600 text-white'
                                : 'text-gray-900',
                              'relative cursor-default select-none py-2 pl-3 pr-9',
                            ]"
                          >
                            <span
                              :class="[
                                selectedCompany
                                  ? 'font-semibold'
                                  : 'font-normal',
                                'block truncate',
                              ]"
                              >{{ option }}</span
                            >

                            <span
                              v-if="selectedCompany"
                              :class="[
                                active ? 'text-white' : 'text-blue-600',
                                'absolute inset-y-0 right-0 flex items-center pr-4',
                              ]"
                            >
                              <CheckIcon class="h-5 w-5" aria-hidden="true" />
                            </span>
                          </li>
                        </ListboxOption>
                      </ListboxOptions>
                    </transition>
                  </div>
                </Listbox>
              </div>
            </div>

            <!-- Filter by Station IATA -->
            <div class="border-b border-gray-400 mb-5">
              <div class="flex h-6 items-center mb-2">
                <input
                  v-model="filterByAirport"
                  id="filterByIata"
                  aria-describedby="filter-description"
                  name="filterByIata"
                  type="checkbox"
                  class="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-600 cursor-pointer"
                />

                <div class="ml-3 text-base leading-6">
                  <label for="filterByIata" class="font-medium text-gray-900"
                    >Filter by Station IATA</label
                  >
                  {{ " " }}
                </div>
              </div>

              <div class="flex my-1 px-5 pb-2" v-if="filterByAirport">
                <Listbox as="div" v-model="selectedIataMatch" class="mb-10">
                  <ListboxLabel
                    class="block text-sm font-medium leading-6 text-gray-900"
                    >Show Employees with Assignments</ListboxLabel
                  >
                  <div class="relative mt-2 min-w-[250px]">
                    <ListboxButton
                      class="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-600 sm:text-sm sm:leading-6"
                    >
                      <span class="block truncate">{{
                        selectedIataMatch
                      }}</span>
                      <span
                        class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2"
                      >
                        <ChevronUpDownIcon
                          class="h-5 w-5 text-gray-400"
                          aria-hidden="true"
                        />
                      </span>
                    </ListboxButton>

                    <transition
                      leave-active-class="transition ease-in duration-100"
                      leave-from-class="opacity-100"
                      leave-to-class="opacity-0"
                    >
                      <ListboxOptions
                        class="absolute z-10 mt-1 max-h-80 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                      >
                        <ListboxOption
                          as="template"
                          v-for="(option, id) in iataMatchOptions"
                          :key="id"
                          :value="option"
                          v-slot="{ active, selectedIataMatch }"
                        >
                          <li
                            :class="[
                              active
                                ? 'bg-blue-600 text-white'
                                : 'text-gray-900',
                              'relative cursor-default select-none py-2 pl-3 pr-9',
                            ]"
                          >
                            <span
                              :class="[
                                selectedIataMatch
                                  ? 'font-semibold'
                                  : 'font-normal',
                                'block truncate',
                              ]"
                              >{{ option }}</span
                            >

                            <span
                              v-if="selectedIataMatch"
                              :class="[
                                active ? 'text-white' : 'text-blue-600',
                                'absolute inset-y-0 right-0 flex items-center pr-4',
                              ]"
                            >
                              <CheckIcon class="h-5 w-5" aria-hidden="true" />
                            </span>
                          </li>
                        </ListboxOption>
                      </ListboxOptions>
                    </transition>
                  </div>
                </Listbox>

                <div class="ml-3">
                  <label
                    for="iata"
                    class="block text-sm font-medium leading-6 text-gray-900"
                    >IATA</label
                  >
                  <div class="mt-2">
                    <input
                      type="text"
                      v-model="selectedIataCode"
                      placeholder="iata"
                      maxlength="3"
                      name="iata"
                      id="iata"
                      class="min-h-9 width-block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>
              </div>
            </div>

            <!-- Filter by Job Title -->
            <div class="border-b border-gray-400 mb-5">
              <div class="mb-2">
                <div class="flex h-6 items-center mb-2">
                  <input
                    v-model="filterByJobTitle"
                    id="filterByJobTitle"
                    aria-describedby="filter-description"
                    name="filterJobTitle"
                    type="checkbox"
                    class="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-600 cursor-pointer"
                  />

                  <div class="ml-3 text-base leading-6">
                    <label
                      for="filterByJobTitle"
                      class="font-medium text-gray-900"
                      >Filter by Job Title</label
                    >
                    {{ " " }}
                  </div>
                </div>

                <div class="flex mt-2" v-if="filterByJobTitle">
                  <div
                    v-if="selectedJobTitles.length !== jobTitleOptions.length"
                    @click="selectedJobTitles = [...jobTitleOptions]"
                    class="cursor-pointer text-base underline text-blue-500"
                  >
                    Selected All
                  </div>
                  <div
                    v-if="selectedJobTitles.length"
                    @click="selectedJobTitles = []"
                    class="ml-2 cursor-pointer text-base underline text-red-500"
                  >
                    Clear Selected
                  </div>
                </div>
              </div>

              <div v-if="filterByJobTitle">
                <div class="relative shadow-md">
                  <table
                    class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400"
                  >
                    <tbody>
                      <tr
                        v-for="jobTitle in jobTitleOptions"
                        :key="jobTitle.name"
                        class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
                      >
                        <td class="w-4 p-4">
                          <div class="flex items-center">
                            <input
                              v-model="selectedJobTitles"
                              :id="jobTitle.name"
                              :value="jobTitle"
                              type="checkbox"
                              class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                            />
                          </div>
                        </td>
                        <td
                          scope="row"
                          class="px-2 py-1 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                        >
                          {{ jobTitle }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <!-- Footer -->
          <div class="flex justify-end mt-1">
            <button
              @click="handleSaveFilters"
              class="btn bg-blue-500 text-white"
            >
              Apply Filters
            </button>
          </div>
        </div>
      </div>
    </r-modal>

    <!-- DATE FILTER DIALOG -->
    <r-modal v-if="showDateFilterDialog" @close="showDateFilterDialog = false">
      <div v-if="showDateFilterDialog" class="p-5">
        <div class="flex justify-between mb-2">
          <div class="text-2xl font-bold">Date Filter</div>
          <button @click="showDateFilterDialog = false" class="btn-icon">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>

        <div class="flex">
          <div>
            <label
              for="date-filter"
              class="block text-sm font-medium leading-6 text-gray-900"
              >Start Date</label
            >

            <input
              class="block w-32 rounded-md border-0 px-3 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-blue-600 sm:text-sm sm:leading-6"
              v-model="startDate"
              type="date"
              id="date-filter"
            />
          </div>

          <div class="ml-3">
            <label
              for="date-filter"
              class="block text-sm font-medium leading-6 text-gray-900"
              >Number of Days</label
            >

            <select
              class="block w-24 py-2 rounded-md border-0 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-blue-600 sm:text-sm sm:leading-6"
              v-model="numberOfDays"
            >
              <option
                v-for="option in numberOfDaysOptions"
                :key="option"
                :value="option"
              >
                {{ option }}
              </option>
            </select>
          </div>
        </div>

        <div class="flex justify-end mt-1">
          <button
            @click="handleSaveDateFilter"
            class="btn bg-blue-500 text-white"
          >
            Apply Filter
          </button>
        </div>
      </div>
    </r-modal>

    <!-- SPECIAL AIRPORTS DIALOG -->
    <r-modal v-if="showSpecialAirportsDialog">
      <SpecialAirports @hide="showSpecialAirportsDialog = false" />
    </r-modal>

    <!-- EMPLOYEE INFORMATION DIALOG -->
    <r-modal
      v-if="showEmployeeInformationDialog"
      @close="showEmployeeInformationDialog = false"
    >
      <employee-information
        :employee="employee"
        :requested-from="'AssignmentBoard'"
        @close="showEmployeeInformationDialog = false"
        @employeeProfileButtonClick="handleNavigateToEmployeeProfile"
      ></employee-information>
    </r-modal>

    <!-- STATION ASSIGNMENT INFORMATION DIALOG -->
    <r-modal
      v-if="showStationAssignmentInformationDialog"
      @close="showStationAssignmentInformationDialog = false"
    >
      <station-assignment-information
        v-if="stationAssignment"
        :groundAssignment="stationAssignment"
        @close="hideStationAssignmentInformationDialog($event)"
      >
      </station-assignment-information>
    </r-modal>

    <!-- NEW TRIP ASSIGNMENT DIALOG -->
    <r-modal
      v-if="showNewTripAssignmentDialog"
      @close="showNewTripAssignmentDialog = false"
    >
      <div class="p-5">
        <div class="flex justify-between mb-2">
          <div class="text-2xl font-bold text-blue-500 mr-2">
            TRIP ASSIGNMENT
          </div>
          <button @click="showNewTripAssignmentDialog = false" class="btn-icon">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>

        <div class="text-2xl font-bold">
          {{ employee.surname }}, {{ employee.givenName }}
        </div>

        <div class="text-xl">
          {{
            `Segments: ${
              assignmentData.trip.flights.length
            },  Total Duty: ${formatElapsedTime(assignmentData.trip.duration)}`
          }}
        </div>

        <div class="horizontal-line-blue my-3"></div>

        <div class="vertical-scroller-400">
          <div v-for="flight in assignmentData.trip.flights" :key="flight._id">
            <div class="flex justify-between py-1">
              <div>{{ formatFlightSnapshot(flight) }}</div>
              <button
                class="btn-text text-blue-500"
                @click="handleSetTripRole(flight._id)"
              >
                {{ getTripFlightRole(flight._id) }}
              </button>
            </div>

            <div class="horizontal-line-gray"></div>
          </div>
          <!-- ASSIGNMENT REMARKS -->
          <div class="text-small text-gray-500">Remarks</div>

          <div class="w-full">
            <div class="mb-2">
              <textarea
                v-model="remarks"
                rows="4"
                name="remarks"
                id="remarks"
                class="block w-full rounded-md border-0 py-1.5 text-base text-blue-700 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:leading-6"
              />
            </div>
          </div>
        </div>

        <div class="flex justify-end mt-2">
          <!-- Role Selector -->
          <div class="flex max-width-300px mr-3">
            <select
              class="block w-48 py-1.5 rounded-md border-0 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-blue-600 sm:text-sm sm:leading-6"
              v-model="selectedRole"
            >
              <option
                v-for="option in authorizedFlightRoles"
                :key="option"
                :value="option"
                :style="{ width: '300px' }"
              >
                {{ option }}
              </option>
            </select>
          </div>

          <div>
            <div>
              <button
                @click="handleSaveTripAssignment"
                class="btn bg-blue-500 text-white"
              >
                Assign Trip
              </button>
            </div>
          </div>
        </div>
      </div>
    </r-modal>

    <!-- NEW STATION ASSIGNMENT DIALOG -->
    <r-modal
      v-if="showNewStationAssignmentDialog"
      @close="showNewStationAssignmentDialog = false"
    >
      <div class="p-5">
        <div class="flex justify-between mb-2">
          <div>
            <div class="text-2xl font-bold text-blue-500 mr-2">
              {{
                `${assignmentData.stationAssignment.originIata} - STATION ASSIGNMENT`
              }}
            </div>
          </div>
          <button
            @click="showNewStationAssignmentDialog = false"
            class="btn-icon"
          >
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>

        <div class="text-2xl font-bold">
          {{ employee.surname }}, {{ employee.givenName }}
        </div>

        <hr class="my-1" />

        <!-- Start / End Times -->
        <div class="flex my-3">
          <div>
            <p class="ml-2 text-sm text-gray-500">Start</p>

            <div class="flex">
              <input
                class="block w-32 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                v-model="startDate"
                type="date"
              />
              <div>
                <input
                  class="ml-2 block w-24 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                  v-model="startTime"
                  type="time"
                />
              </div>
            </div>
          </div>

          <div>
            <p class="ml-2 text-sm text-gray-500">End</p>
            <div class="flex">
              <input
                class="block w-32 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                v-model="endDate"
                type="date"
              />

              <div>
                <input
                  class="ml-2 block w-24 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                  v-model="endTime"
                  type="time"
                />
              </div>
            </div>
          </div>

          <!-- Button to calculate the valid cover period -->
          <div class="ml-4 self-end">
            <button
              @click="handleGetCalculatedCoverPeriod"
              class="btn bg-gray-500 text-white cursor-pointer"
            >
              Get times based on flights
            </button>
          </div>
        </div>

        <div v-if="warningText">
          <div
            class="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 mb-2 cursor-pointer"
            role="alert"
            @click="warningText = null"
          >
            <p class="font-bold">Warning</p>
            <p>{{ warningText }}</p>
          </div>
        </div>
        <div v-else class="text-xl">
          {{ `Total Duty: ${formatElapsedTime(stationAssignmentDuration)}` }}
        </div>

        <hr class="my-2" />

        <div class="vertical-scroller-400">
          <div
            v-for="flight in assignmentData.stationAssignment.flights"
            :key="flight._id"
          >
            <div>
              {{ formatStationAssignmentFlightSnapshot(flight) }}
            </div>
            <hr class="my-1" />
          </div>

          <!-- ASSIGNMENT REMARKS -->
          <div class="text-small text-gray-500">Remarks</div>

          <div class="w-full">
            <div class="mb-2">
              <textarea
                v-model="remarks"
                rows="4"
                name="remarks"
                id="remarks"
                class="block w-full rounded-md border-0 py-1.5 text-base text-blue-700 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:leading-6"
              />
            </div>
          </div>
        </div>

        <div class="flex justify-end mt-2">
          <!-- Role Selector -->
          <div class="flex max-width-300px mr-3">
            <select
              class="block w-48 py-1.5 rounded-md border-0 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-blue-600 sm:text-sm sm:leading-6"
              v-model="selectedRole"
            >
              <option
                v-for="option in authorizedFlightRoles"
                :key="option"
                :value="option"
                :style="{ width: '300px' }"
              >
                {{ option }}
              </option>
            </select>
          </div>

          <div>
            <div>
              <button
                @click="handleSaveStationAssignment"
                class="btn bg-blue-500 text-white"
              >
                Assign
              </button>
            </div>
          </div>
        </div>
      </div>
    </r-modal>

    <!-- #endregion -->

    <!-- #region FLIGHT ASSIGNMENTS -->
    <!-- FLIGHT ASSIGNMENT INFORMATION DIALOG -->

    <!-- NEW FLIGHT ASSIGNMENT DIALOG -->
    <r-modal
      v-if="showNewFlightAssignmentDialog"
      @close="showNewFlightAssignmentDialog = false"
    >
      <div class="p-5 bg-blue-200">
        <div class="flex justify-between mb-2">
          <div class="text-2xl font-bold">
            {{
              ` ${employee.surname}, ${employee.givenName} -
            ${employee.companyName}`
            }}
          </div>
          <button
            @click="showNewFlightAssignmentDialog = false"
            class="btn-icon"
          >
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>

        <div class="text-base my-1">
          {{ formatFlightSnapshot(assignmentData.flight) }}
        </div>
        <div class="vertical-scroller-400">
          <!-- CREWMEMBERS -->
          <div>
            <!-- FLIGHT CREWMEMBERS -->
            <div>Flight Crewmembers</div>
            <div v-if="assignmentData.flight.crewmembers?.length">
              <div
                v-for="crewmember in assignmentData.flight.crewmembers"
                :key="crewmember._id"
              >
                <div
                  v-if="crewmember.employee"
                  class="flex justify-between align-center text-xs"
                >
                  <div class="flex w-full border-b border-gray-500 py-1">
                    <div>{{ crewmember.role }}:</div>
                    <div class="ml-2">
                      {{ crewmember.employee.surname }},
                      {{ crewmember.employee.givenName }}
                    </div>
                  </div>
                </div>
                <div v-else class="flex justify-between align-center text-xs">
                  <div class="flex w-full border-b border-gray-500 py-1">
                    <div>{{ crewmember.role }}:</div>
                    <div class="ml-2 text-red-500">
                      {{ crewmember.assignedToCompany }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="text-xs text-red-500">
              No flight crewmembers assigned
            </div>
          </div>

          <div class="horizontal-line-blue my-2"></div>

          <!-- GROUND CREWMEMBERS -->
          <div class="mt-2">
            <div>Ground Crewmembers</div>
            <div
              class="mb-1"
              v-if="assignmentData.flight.groundCrewmembers.length > 0"
            >
              <div
                v-for="groundCrewmember in assignmentData.flight
                  .groundCrewmembers"
                :key="groundCrewmember._id"
              >
                <div
                  v-if="groundCrewmember.employee"
                  class="flex justify-between align-center"
                >
                  <div class="flex text-xs">
                    <div>
                      {{
                        `${groundCrewmember.role} (${groundCrewmember.originIata})`
                      }}:
                    </div>
                    <div class="ml-2">
                      {{ groundCrewmember.employee.surname }},
                      {{ groundCrewmember.employee.givenName }}
                    </div>
                  </div>
                </div>
                <div v-else class="flex justify-between align-center">
                  <div class="flex">
                    <div>
                      {{
                        `${groundCrewmember.role} (${groundCrewmember.originIata})`
                      }}:
                    </div>
                    <div>
                      {{ groundCrewmember.assignedToCompany }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="text-xs text-red-500">
              No ground crewmembers assigned
            </div>
          </div>

          <div class="horizontal-line-blue my-2"></div>

          <!-- ASSIGNMENT REMARKS -->
          <div class="text-small text-gray-500">Remarks</div>

          <div class="w-full">
            <div class="mb-2">
              <textarea
                v-model="remarks"
                rows="4"
                name="remarks"
                id="remarks"
                class="block w-full rounded-md border-0 py-1.5 text-base text-blue-700 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:leading-6"
              />
            </div>
          </div>
        </div>

        <div class="flex justify-end mt-2">
          <!-- Role Selector -->
          <div class="flex mr-3">
            <select
              class="block w-48 py-2 rounded-md border-0 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-blue-600 sm:text-sm sm:leading-6 cursor-pointer"
              v-model="selectedRole"
            >
              <option
                v-for="option in authorizedFlightRoles"
                :key="option"
                :value="option"
              >
                {{ option }}
              </option>
            </select>
          </div>

          <div>
            <button
              class="btn bg-blue-500 text-white"
              @click="handleSaveFlightAssignment"
            >
              Assign
            </button>
          </div>
        </div>
      </div>
    </r-modal>

    <!-- FLIGHT ASSIGNMENT INFOMATION -->
    <r-modal
      v-if="showFlightAssignmentInformationDialog"
      @close="showFlightAssignmentInformationDialog = false"
    >
      <FlightAssignmentInformation
        v-if="flightAssignment"
        :flightAssignment="flightAssignment"
        @close="hideFlightAssignmentInformationDialog($event)"
      ></FlightAssignmentInformation>
    </r-modal>

    <!-- #endregion -->

    <!-- #region GROUND ASSIGNMENTS -->

    <!-- NEW GROUND ASSIGNMENT DIALOG -->
    <r-modal
      v-if="showNewGroundAssignmentDialog"
      @close="showNewGroundAssignmentDialog = false"
    >
      <div v-if="showNewGroundAssignmentDialog" class="p-5">
        <div class="flex justify-between mb-2">
          <div class="text-2xl">NEW ASSIGNMENT</div>
          <button
            @click="showNewGroundAssignmentDialog = false"
            class="btn-icon"
          >
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>

        <div class="text-2xl">
          {{ `${employee.surname}, ${employee.givenName}` }}
        </div>
        <div class="text-xl text-blue-600">
          {{ `(${employee.companyName} - ${employee.companyId.number})` }}
        </div>

        <div class="my-2">
          <!-- GROUND ASSIGNMENT TYPE-->

          <div class="flex">
            <select
              class="block w-48 py-2 rounded-md border-0 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-blue-600 sm:text-sm sm:leading-6"
              v-model="selectedGroundAssignmentType"
              :items="groundAssignmentTypes"
            >
              <option v-for="option in groundAssignmentTypes" :key="option">
                {{ option }}
              </option>
            </select>
            <div
              class="ml-3 flex items-center"
              v-if="
                selectedGroundAssignmentType === 'Travel' ||
                selectedGroundAssignmentType === 'Layover'
              "
            >
              <Switch
                v-model="groundAssignmentConfirmed"
                class="group relative inline-flex h-5 w-10 flex-shrink-0 cursor-pointer items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2"
              >
                <span class="sr-only">Use setting</span>
                <span
                  aria-hidden="true"
                  class="pointer-events-none absolute h-full w-full rounded-md bg-white"
                />
                <span
                  aria-hidden="true"
                  :class="[
                    groundAssignmentConfirmed ? 'bg-green-600' : 'bg-gray-200',
                    'pointer-events-none absolute mx-auto h-4 w-9 rounded-full transition-colors duration-200 ease-in-out',
                  ]"
                />
                <span
                  aria-hidden="true"
                  :class="[
                    groundAssignmentConfirmed
                      ? 'translate-x-5'
                      : 'translate-x-0',
                    'pointer-events-none absolute left-0 inline-block h-5 w-5 transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out',
                  ]"
                />
              </Switch>

              <div class="ml-3">
                {{ groundAssignmentConfirmed ? "Confirmed" : "Not Confirmed" }}
              </div>
            </div>
          </div>

          <!-- GROUND ASSIGNMENT  LOCATIONS -->

          <div class="flex my-2">
            <div class="max-width-200px" :class="{ hidden: !showOriginInput }">
              <p class="ml-2 text-sm text-gray-500">From</p>

              <input
                class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                v-model="groundAssignmentOriginIata"
                type="text"
                maxlength="3"
                name="originIata"
                id="originIata"
                placeholder="IATA"
              />
            </div>

            <div
              class="max-width-200px"
              :class="{ hidden: !showDestinationInput }"
            >
              <p class="ml-2 text-sm text-gray-500">To</p>
              <input
                v-model="groundAssignmentDestinationIata"
                type="text"
                maxlength="3"
                name="destinationIata"
                id="destinationIata"
                class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                placeholder="IATA"
              />
            </div>
          </div>

          <!-- START DATE AND TIME -->
          <div class="flex mb-2">
            <div>
              <p class="ml-2 text-sm text-gray-500">Start</p>
              <div
                class="flex items-center my-2"
                v-if="selectedGroundAssignmentType"
              >
                <input
                  class="block w-32 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                  v-model="groundAssignmentStartDate"
                  type="date"
                />

                <div :class="{ hidden: !showTimes }">
                  <input
                    class="ml-1 block w-24 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                    v-model="groundAssignmentStartTime"
                    type="time"
                  />
                </div>
              </div>
            </div>

            <div class="mx-5"></div>

            <div>
              <p class="ml-2 text-sm text-gray-500">End</p>
              <div
                class="flex items-center my-2"
                v-if="selectedGroundAssignmentType"
              >
                <input
                  class="block w-32 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                  v-model="groundAssignmentEndDate"
                  type="date"
                />
                <div :class="{ hidden: !showTimes }">
                  <input
                    class="ml-1 block w-24 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                    v-model="groundAssignmentEndTime"
                    type="time"
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- ASSIGNMENT REMARKS -->
          <div class="text-small text-gray-500">Remarks</div>

          <div class="w-full">
            <div class="mb-2">
              <textarea
                v-model="remarks"
                rows="4"
                name="remarks"
                id="remarks"
                class="block w-full rounded-md border-0 py-1.5 text-base text-blue-700 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:leading-6"
              />
            </div>
          </div>
        </div>
        <div class="flex justify-end mt-2">
          <div>
            <div>
              <button
                @click="handleSaveGroundAssignment"
                class="btn bg-blue-500 text-white"
              >
                Assign
              </button>
            </div>
          </div>
        </div>
      </div>
    </r-modal>

    <!-- GROUND ASSIGNMENT INFORMATION DIALOG -->
    <r-modal
      v-if="showGroundAssignmentInformationDialog"
      @close="showGroundAssignmentInformationDialog = false"
    >
      <ground-assignment-information
        v-if="groundAssignment"
        :groundAssignment="groundAssignment"
        @close="handleCloseGroundAssignmentInformationDialog($event)"
        @update="handleUpdateGroundAssignment($event)"
      >
      </ground-assignment-information>
    </r-modal>
    <!-- #endregion -->

    <!-- #region BOARD -->
    <div class="board" ref="board">
      <!-- LEFT PANEL -->
      <div v-if="boardStyle === 'Board' && page" class="left-panel">
        <div class="left-panel-header bg-gray-500-l2">
          <div class="text-base flex justify-center items-center w-[90px]">
            Employees
          </div>
        </div>
        <div
          class="left-panel-row bg-gray-500-l4 cursor-pointer"
          @click="handleShowEmployeeInformationDialog(item.employee)"
          v-for="item in page.items"
          :key="item.employee._id"
          :style="{ height: `${rowHeight}px` }"
        >
          <div class="text-base text-align text-bold text-truncate">
            {{
              `${item.employee.surname}, ${item.employee.givenName.substring(
                0,
                1
              )}`
            }}
          </div>
          <div class="text-[10px] text-truncate">
            {{ `${item.employee.companyName} - ${item.employee.jobTitle}` }}
          </div>
          <div class="text-xs text-truncate">
            {{
              `${item.employee.gatewayCode} - ${item.employee.companyId.number}`
            }}
          </div>
        </div>
      </div>
      <!-- RIGHT PANEL -->
      <div
        v-if="boardStyle === 'Board'"
        class="right-panel-container"
        ref="scrollContainer"
      >
        <div v-if="page" class="right-panel">
          <!-- Flight Tooltip -->
          <div
            class="flight-tooltip text-[12px]"
            :style="tooltipStyle"
            v-if="tooltip"
          >
            <div class="border-b border-gray-500 pb-1 mb-1 text-base">
              {{ tooltip.customerName }}
            </div>

            <div>
              {{
                `${tooltip.flightNumber} . ${tooltip.aircraftRegistration} . ${tooltip.originIata} - ${tooltip.destinationIata} `
              }}
            </div>

            <div class="border-b border-gray-500 pb-1 mb-1">
              {{
                `${formatDateTime(tooltip.startTime)} . ${formatTime(
                  tooltip.endTime
                )}`
              }}
            </div>

            <div
              v-if="
                tooltip.flightCrewmembers &&
                tooltip.flightCrewmembers.length > 0
              "
            >
              <div
                class="flex"
                v-for="crewmember in tooltip.flightCrewmembers"
                :key="crewmember._id"
              >
                <div>{{ crewmember.role }}:</div>
                <div v-if="crewmember.employee" class="ml-1">
                  {{ crewmember.employee.surname }},
                  {{ crewmember.employee.givenName }}
                </div>
                <div v-else>
                  {{ crewmember.assignedToCompany }}
                </div>
              </div>
            </div>
            <div v-else>No flight crewmembers assigned.</div>

            <!-- <div class="flex">
              <div>{{ tooltip.role }}:</div>
              <div class="ml-1">
                {{ tooltip.employee.surname }},
                {{ tooltip.employee.givenName }}
              </div>
            </div> -->
          </div>
          <!-- Header -->
          <div
            class="right-panel-header bg-gray-500-l4 hover:bg-gray-200 cursor-pointer"
            @click="handleOpenDateFilter(item)"
            v-for="(item, index) in dateFilter.days"
            :key="index"
            :style="{
              top: 0,
              left: `${(1440 / scale) * index}px`,
              width: `${dayWidth}px`,
            }"
          >
            {{ formatHeaderDate(item) }}
          </div>

          <!-- Day Lines -->
          <div
            class="day-line"
            v-for="(day, index) in dateFilter.days"
            :key="day"
            :style="{
              left: `${(1440 / scale) * index}px`,
              height: `${availableBoardHeight + 50}px`,
            }"
          ></div>

          <!-- Hour Boxes -->
          <div
            class="hour-box text-[10px]"
            :class="{ hidden: marker.value === '00' || scale > 4 }"
            v-for="(marker, index) in dateFilter.hourBoxes"
            :key="marker.key"
            :style="{ left: `${(60 / scale) * index}px` }"
          >
            {{ marker.value }}
          </div>

          <!-- Hour Lines -->
          <div
            class="hour-line"
            :class="{ hidden: marker.value === '00' || scale > 6 }"
            v-for="(marker, index) in dateFilter.hourLines"
            :key="marker.key"
            :style="{
              left: `${(60 / scale) * index}px`,
              height: `${availableBoardHeight + 7}px`,
            }"
          ></div>

          <!-- Now Box -->
          <div
            class="now-box"
            v-if="showCurrentTime"
            :style="{
              left: `${nowLineLeft}px`,
            }"
          >
            {{ formatTime(new Date()) }}
          </div>

          <!-- Now Line -->
          <div
            class="now-line"
            v-if="showCurrentTime"
            :style="{
              left: `${nowLineLeft}px`,
              height: `${availableBoardHeight + 7}px`,
            }"
          ></div>

          <!-- Employees -->
          <div
            class="right-panel-row"
            @click="handleStartNewGroundAssignment(item, $event)"
            v-for="(item, index) in page.items"
            :key="item.employee._id"
            :style="{
              top: `${index * rowHeight + 50}px`,
              width: `${boardWidth}px`,
              height: `${rowHeight}px`,
            }"
          >
            <!-- Bid Days -->
            <div
              v-for="bidday in item.employee.biddays"
              :key="`${item.employee._id}-${bidday.year}-${bidday.month}-${bidday.day}`"
              class="bidday-panel"
              :style="getBidDayStyle(bidday)"
            >
              {{ bidday.description }}
            </div>

            <!-- Assignment Shadow  -->
            <div
              v-if="assignmentData?.isVisible"
              class="assignment-shadow"
              @click="handleAssignmentShadowClicked(item, $event)"
              :style="computedAssignmentShadow"
            >
              <div>
                {{ shadowText }}
              </div>
            </div>
            <!--Assignments-->
            <div v-for="assignment in item.assignments" :key="assignment._id">
              <!-- Flight Assignment -->
              <div
                v-if="assignment.type === 'Flight'"
                @click="
                  handleShowFlightAssignmentInformationDialog(
                    assignment,
                    $event
                  )
                "
                @mouseover="handleShowFlightTooltip(assignment, index)"
                @mouseleave="handleHideFlightTooltip"
                class="board-label-frame"
                :style="{
                  width: `${assignment.duration / scale}px`,
                  left: `${getLocationLeft(
                    assignment.startTime,
                    dateFilter.days[0],
                    scale
                  )}px`,
                }"
              >
                <FlightAssignmentLabel :assignment="assignment" />
              </div>

              <!-- Station Assignment -->
              <div
                v-else-if="assignment.type === 'Station Assignment'"
                @click="
                  handleShowStationAssignmentInformationDialog(
                    assignment,
                    $event
                  )
                "
                class="board-label-frame"
                :style="{
                  width: `${assignment.duration / scale}px`,
                  left: `${getLocationLeft(
                    assignment.startTime,
                    dateFilter.days[0],
                    scale
                  )}px`,
                }"
              >
                <StationAssignmentLabel :assignment="assignment" />
              </div>

              <!-- Ground Assignment -->
              <div
                v-else
                @click="
                  handleShowGroundAssignmentInformationDialog(
                    item,
                    assignment,
                    $event
                  )
                "
                class="board-label-frame"
                v-bind:style="{
                  width: `${assignment.duration / scale}px`,
                  left: `${getLocationLeft(
                    assignment.startTime,
                    dateFilter.days[0],
                    scale
                  )}px`,
                }"
              >
                <GroundAssignmentLabel :groundAssignment="assignment" />
              </div>
            </div>
          </div>
        </div>
        <div v-else class="right-panel">
          <div v-if="loading" class="ma-5 text-red-500 text-2xl">
            Loading ...
          </div>
          <div v-else class="ma-5 text-red-500 text-2xl">
            No employees found with the selected criteria
          </div>
        </div>
      </div>

      <!-- LIST -->
      <div v-if="boardStyle === 'List' && page">
        <div
          v-if="assignmentsList.length"
          class="flex flex-col justify-between"
        >
          <!-- Data Table -->
          <div class="relative overflow-x-auto">
            <table
              class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400"
            >
              <thead
                class="text-xs text-gray-200 uppercase bg-gray-500 dark:bg-gray-700 dark:text-gray-400"
              >
                <tr>
                  <th
                    scope="col"
                    class="p-4"
                    v-if="
                      user.securityGroup.keys.includes(23) ||
                      user.securityGroup.keys.includes(27) ||
                      user.securityGroup.keys.includes(114)
                    "
                  >
                    <div class="flex items-center">
                      <input
                        v-model="selectAll"
                        @click="handleToggleSelectAll"
                        id="checkbox-all-search"
                        type="checkbox"
                        class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600 cursor-pointer"
                      />
                      <label for="checkbox-all-search" class="sr-only"
                        >checkbox</label
                      >
                    </div>
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-3 cursor-pointer"
                    @click="sortArrayByKey('employee.surname')"
                  >
                    Last Name
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-3 cursor-pointer"
                    @click="sortArrayByKey('employee.givenName')"
                  >
                    First Name
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-3 cursor-pointer"
                    @click="sortArrayByKey('employee.jobTitle')"
                  >
                    Job Title
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-3 cursor-pointer"
                    @click="sortArrayByKey('employee.company')"
                  >
                    Company
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-3 cursor-pointer"
                    @click="sortArrayByKey('from')"
                  >
                    FROM
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-3 cursor-pointer"
                    @click="sortArrayByKey('to')"
                  >
                    TO
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-3 cursor-pointer"
                    @click="sortArrayByKey('start')"
                  >
                    Start
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-3 cursor-pointer"
                    @click="sortArrayByKey('end')"
                  >
                    End
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-3 cursor-pointer"
                    @click="sortArrayByKey('type')"
                  >
                    Assignment Type
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-3 cursor-pointer"
                    @click="sortArrayByKey('assignedBy')"
                  >
                    Assigned By
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="assignment in assignmentsList"
                  :key="assignment._id"
                  class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
                >
                  <td class="w-4 p-4">
                    <div class="flex items-center">
                      <input
                        v-model="assignment.selected"
                        :id="assignment.id"
                        :value="assignment"
                        type="checkbox"
                        class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      />
                    </div>
                  </td>
                  <td
                    scope="row"
                    class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                  >
                    {{ assignment.employee.surname }}
                  </td>
                  <td>{{ assignment.employee.givenName }}</td>
                  <td class="px-6 py-2">
                    {{ assignment.employee.jobTitle }}
                  </td>
                  <td class="px-6 py-2">
                    {{ assignment.employee.companyName }}
                  </td>
                  <td class="px-6 py-2">
                    {{ assignment.originIata }}
                  </td>
                  <td class="px-6 py-2">
                    {{ assignment.destinationIata }}
                  </td>
                  <td class="px-6 py-2">
                    {{ formatDateTime(assignment.startTime) }}
                  </td>
                  <td class="px-6 py-2">
                    {{ formatDateTime(assignment.endTime) }}
                  </td>
                  <td class="px-6 py-2">{{ assignment.type }}</td>
                  <td class="px-6 py-2">{{ assignment.assignedBy }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="flex justify-end my-3 p-2">
            <button
              v-if="
                selectedAssignments.length &&
                (user.securityGroup.keys.includes(23) ||
                  user.securityGroup.keys.includes(27) ||
                  user.securityGroup.keys.includes(114))
              "
              @click="handleDeleteAssignments"
              class="btn bg-red-500 text-white"
            >
              Remove Selected
            </button>
          </div>
        </div>

        <div v-else class="ma-5 text-red-500 text-2xl p-5">
          No assignments found with the selected criteria
        </div>
      </div>
    </div>

    <!-- #endregion -->
  </div>
</template>

<script>
import api from "../services/api";
import authentication from "../services/authentication";
import { mixin } from "../mixins/mixin";
import FlightAssignmentLabel from "../components/FlightAssignmentLabel.vue";
import StationAssignmentLabel from "../components/StationAssignmentLabel.vue";
import GroundAssignmentLabel from "../components/GroundAssignmentLabel.vue";
import SpecialAirports from "../components/SpecialAirports.vue";
import FlightAssignmentInformation from "../components/FlightAssignmentInformation.vue";
import GroundAssignmentInformation from "../components/GroundAssignmentInformation.vue";
import StationAssignmentInformation from "../components/StationAssignmentInformation.vue";
import EmployeeInformation from "../components/EmployeeInformation.vue";

import RSnackbar from "../components/RSnackbar.vue";
import RSpinner from "../components/RSpinner.vue";
import RModal from "../components/RModal.vue";
import {
  Listbox,
  ListboxButton,
  ListboxLabel,
  ListboxOption,
  ListboxOptions,
  Switch,
} from "@headlessui/vue";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/vue/20/solid";

export default {
  name: "assignmentBoard",
  mixins: [mixin],
  components: {
    FlightAssignmentInformation,
    GroundAssignmentInformation,
    StationAssignmentInformation,
    EmployeeInformation,
    FlightAssignmentLabel,
    StationAssignmentLabel,
    GroundAssignmentLabel,
    SpecialAirports,

    RSnackbar,
    RSpinner,
    RModal,
    Listbox,
    ListboxButton,
    ListboxLabel,
    ListboxOption,
    ListboxOptions,
    CheckIcon,
    ChevronUpDownIcon,
    Switch,
  },
  data() {
    return {
      loading: false,

      inactivityTimer: null,
      selectAll: false,

      assignment: null,

      tooltip: null,
      tooltipStyle: {
        display: "none",
      },

      totalEmployees: 0,
      assignmentsList: [],

      //#region-----------------------------------Paginate
      availableBoardHeight: 0,
      employeesSchedule: [],
      filteredEmployeesSchedule: [],
      itemsPerPage: 0,
      printGroundCrewmembers: true,
      pages: [],
      page: null,
      // page: { index: 0, items: [] },
      rowHeight: 60,
      disableNextPageButton: true,
      disablePreviousPageButton: true,
      //#endregion

      //----------------------------------------Board
      boardStyle: "Board",
      scale: 4,

      originIata: "", //Used to sort station assignment flights
      paddingBefore: 30,
      paddingAfter: 30,

      filterByStation: {
        active: false,
        startTime: new Date(),
        originIata: "",
      },

      //------------------------------------------Employee
      employeeDialog: false,
      showEmployeeInformationDialog: false,
      employee: null,
      workMonth: null,

      //------------------------------------------Filters and Settings
      showFiltersDialog: false,

      iataMatchOptions: ["Departing or Arriving", "Departing", "Arriving"],

      filterByAirport: false,
      filterByCompany: false,
      selectedIataCode: null,
      selectedIataMatch: "Departing or Arriving",

      filterByAircraftDeck: false,
      selectedAircraftDeck: null,
      aircraftDeckOptions: ["Cargo Aircraft", "Passenger Aircraft"],

      filterByCompany: false,
      selectedCompany: null,

      search: "",

      showDateFilterDialog: false,
      startDate: null,
      numberOfDays: 7,
      numberOfDaysOptions: [3, 5, 7, 14, 21, 31],

      filterByJobTitle: false,
      selectedJobTitles: [],

      //-------------------------------Flight Assignments
      flightAssignment: null,
      showNewFlightAssignmentDialog: false,
      showFlightAssignmentInformationDialog: false,

      remarks: "",
      selectedRole: null,

      //-------------------------------Trip Assignments

      showTripAssignmentInformationDialog: false,
      showNewTripAssignmentDialog: false,
      tripRoles: null,

      //-------------------------------Station Assignments
      stationAssignment: null,
      showNewStationAssignmentDialog: false,
      showStationAssignmentInformationDialog: false,
      startDate: null,
      startTime: null,
      endDate: null,
      endTime: null,

      //-------------------------------Assignments (Shared)
      assignmentWarnings: [],

      // -----------------------------------------Ground Assignments
      showGroundAssignmentInformationDialog: false,
      groundAssignment: null,
      groundAssignmentMinimumDuration: 30,
      showGroundAssignmentStartCalendar: false,
      showGroundAssignmentEndCalendar: false,
      selectedGroundAssignmentType: "",
      groundAssignmentConfirmed: false,
      groundAssignmentOrigin: null,
      groundAssignmentDestination: null,
      groundAssignmentStartDate: new Date().toISOString().substring(0, 10),
      groundAssignmentStartTime: "00:00",
      groundAssignmentEndDate: new Date().toISOString().substring(0, 10),
      groundAssignmentEndTime: "23:59",
      groundAssignmentStartDateTime: new Date(),
      groundAssignmentEndDateTime: new Date(),
      groundAssignmentDuration: 0,
      groundAssignmentOriginIata: "",
      groundAssignmentDestinationIata: "",
      groundAssignmentTypeRules: [(v) => !!v || "Assignment Type is required"],

      showNewGroundAssignmentDialog: false,
      groundAssignmentStart: "",
      showStartCalendar: false,
      showEndCalendar: false,

      //-------------------------Snackbar
      snackbarVisible: false,
      snackbarText: "",
      snackbarColor: "white",
      snackbarTimeout: 5000,

      //-------------------------------General Warnings
      filteredWarnings: [],
      showAssigmentWarningsModal: false,
      showWarningsDialog: false,

      warningTypeOptions: [
        "All Warnings",
        "Assignment Overlap",
        "Route Discontinuity",
        "Travel (Unconfirmed)",
        "Layover (Unconfirmed)",
        "Station Assignment",
      ],

      selectedWarningType: "All Warnings",

      warningText: null,
      stationAssignmentDuration: 0,

      //-----------------------------Special Airports
      showSpecialAirportsDialog: false,
    };
  },

  created() {
    (async () => {
      this.getData();
    })();
  },
  mounted() {
    this.$nextTick(() => {
      const board = this.$refs.board;

      this.availableBoardHeight = board.clientHeight - 120;

      this.itemsPerPage = Math.floor(
        this.availableBoardHeight / this.rowHeight
      );

      if (this.assignmentData) {
        switch (this.assignmentData.type) {
          case "Trip Assignment":
            this.tripRoles = new Map();

            this.assignmentData.trip.flights.forEach((flight) => {
              this.tripRoles.set(flight._id, null);
            });

            break;

          case "Station Assignment":
            this.startDate = new Date(
              this.assignmentData.stationAssignment.startTime
            )
              .toISOString()
              .substring(0, 10);
            this.startTime = new Date(
              this.assignmentData.stationAssignment.startTime
            )
              .toISOString()
              .substring(11, 16);

            this.endDate = new Date(
              this.assignmentData.stationAssignment.endTime
            )
              .toISOString()
              .substring(0, 10);
            this.endTime = new Date(
              this.assignmentData.stationAssignment.endTime
            )
              .toISOString()
              .substring(11, 16);

            break;

          default:
            break;
        }
      }
    });

    window.addEventListener("resize", this.onResize, { passive: true });

    this.startInactivityTimer();
    document.addEventListener("click", this.resetInactivityTimer);
  },

  unmounted() {
    this.clearInactivityTimer();
    document.removeEventListener("click", this.resetInactivityTimer);
  },

  beforeDestroy() {
    if (typeof window === "undefined") return;
    window.removeEventListener("resize", this.onResize, { passive: true });
  },

  watch: {
    selectedWarningType() {
      // Update filteredWarnings whenever the selected warning type changes
      this.filteredWarnings = [...this.warnings];
    },
    startDate() {
      this.updateStationAssignmentDuration();
    },
    startTime() {
      this.updateStationAssignmentDuration();
    },
    endDate() {
      this.updateStationAssignmentDuration();
    },
    endTime() {
      this.updateStationAssignmentDuration();
    },
  },

  computed: {
    auth() {
      return this.$store.state.auth;
    },

    hardWarnings() {
      return this.assignmentWarnings.filter((item) => {
        return item.level === "Hard";
      });
    },

    assignmentData() {
      return this.$store.getters.assignmentData;
    },

    shadowText() {
      switch (this.assignmentData.type) {
        case "Flight Assignment":
          return `${this.assignmentData.flight.aircraft.registration} . ${this.assignmentData.flight.flightNumber} . ${this.assignmentData.flight.originIata} - ${this.assignmentData.flight.destinationIata}`;
        case "Trip Assignment":
          return `Trip ${this.assignmentData.trip.route}`;
        default:
          return `Station Assignment: ${this.assignmentData.stationAssignment.originIata}`;
      }
    },

    aircraftDeckFilter() {
      return this.$store.getters.aircraftDeckFilter;
    },

    assignmentsAirportFilter() {
      return this.$store.getters.assignmentsAirportFilter;
    },

    companyFilter() {
      return this.$store.getters.companyFilter;
    },

    jobTitlesFilter() {
      return this.$store.getters.jobTitlesFilter;
    },

    warnings() {
      let warnings = [];

      if (this.filteredEmployeesSchedule) {
        let priorAssignment;
        let assignment;
        let timeOut;
        let timeIn;
        let timeNow = new Date().getTime();
        let ts = 0;

        this.filteredEmployeesSchedule.forEach((item) => {
          if (item.assignments.length) {
            const assignments = item.assignments.sort(this.compareAssignments);

            priorAssignment = item.assignments[0];

            for (let i = 0; i < assignments.length; i++) {
              assignment = item.assignments[i];
              assignment.hasConflict = false;

              // Check Station Assignment Auto-Adjustment
              if (
                assignment.type === "Station Assignment" &&
                assignment.autoAdjusted === true
              ) {
                warnings.push({
                  employee: { ...item.employee, assignments: item.assignments },
                  assignment,
                  level: "Soft",
                  type: "Station Assignment",
                  message: `Station Assignment  ${assignment.originIata} cover period was auto-adjusted due to flight schedule changes.`,
                });
              }

              if (i > 0) {
                //Check discontinuity starting on the second assignment

                timeOut = new Date(assignment.startTime).getTime();
                timeIn = new Date(priorAssignment.endTime).getTime();

                if (assignment.originIata !== priorAssignment.destinationIata) {
                  assignment.hasConflict = true;
                  warnings.push({
                    employee: {
                      ...item.employee,
                      assignments: item.assignments,
                    },
                    assignment,
                    level: "Soft",
                    type: "Route Discontinuity",
                    message: `Assignment starts in ${
                      assignment.originIata
                    } on ${this.formatDateTime(
                      assignment.startTime
                    )}, prior assignment ended in ${
                      priorAssignment.destinationIata
                    } on ${this.formatDateTime(priorAssignment.endTime)}`,
                  });
                }

                if (timeOut < timeIn) {
                  assignment.hasConflict = true;
                  warnings.push({
                    employee: {
                      ...item.employee,
                      assignments: item.assignments,
                    },
                    assignment,
                    level: "Soft",
                    type: "Time Overlap",
                    message: `Assignment starts in ${
                      assignment.originIata
                    } on ${this.formatDateTime(
                      assignment.startTime
                    )}, prior assignment ended in ${
                      priorAssignment.destinationIata
                    } on ${this.formatDateTime(priorAssignment.endTime)}`,
                  });
                }
              }

              // Check Travel/Layover Confirmation

              if (
                (assignment.type === "Travel" ||
                  assignment.type === "Layover") &&
                !assignment.confirmed
              ) {
                timeOut = new Date(assignment.startTime).getTime();
                ts = (timeOut - timeNow) / (1000 * 60 * 60);

                //Add warning if unconfirmed in the next 72 hours
                if (ts > 0 && ts < 72) {
                  assignment.hasConflict = true;
                  warnings.push({
                    employee: {
                      ...item.employee,
                      assignments: item.assignments,
                    },
                    assignment,
                    level: "Soft",
                    type: `Unconfirmed ${assignment.type}`,
                    message: `Unconfirmed ${
                      assignment.type
                    } on ${this.formatDateTime(assignment.startTime)}`,
                  });
                }
              }

              priorAssignment = { ...assignment };
            }
          }
        });
      }

      // Filter warnings based on selectedWarningType before returning
      let filteredWarnings = warnings;

      switch (this.selectedWarningType) {
        case "Assignment Overlap":
          filteredWarnings = warnings.filter(
            (warning) => warning.type === "Time Overlap"
          );
          break;
        case "Route Discontinuity":
          filteredWarnings = warnings.filter(
            (warning) => warning.type === "Route Discontinuity"
          );
          break;
        case "Travel (Unconfirmed)":
          filteredWarnings = warnings.filter(
            (warning) => warning.type === "Unconfirmed Travel"
          );
          break;
        case "Layover (Unconfirmed)":
          filteredWarnings = warnings.filter(
            (warning) => warning.type === "Unconfirmed Layover"
          );
          break;
        case "Station Assignment":
          filteredWarnings = warnings.filter(
            (warning) => warning.type === "Station Assignment"
          );
          break;
        default:
          filteredWarnings = warnings;
      }

      return filteredWarnings;
    },

    pageNumber() {
      return this.$store.getters.assignmentBoardPageNumber;
    },

    showOriginInput() {
      switch (this.selectedGroundAssignmentType) {
        case "Special Assignment":
        case "Layover":
        case "Training - Ground School":
        case "Training - SIM":
        case "Do Not Use":
        case "Sick":
        case "Quarantine":
        case "Quarantine - Day OFF":
        case "Travel":
          return true;

        default:
          // case "Vacation":
          // case "Holiday":
          // case "LOA - Jury Duty":
          // case "LOA - Long Term Disability":
          // case "LOA - Short Term Disability":
          // case "LOA - Workers' Compensation":
          // case "Floating Holiday":
          // case "Leave - Bereavement":
          // case "Leave - FMLA":
          // case "Leave - Medical":
          // case "Leave - Military":
          // case "Leave - Non-FMLA":
          // case "Leave - Parental":
          // case "Leave - Personal":
          // case "Stand By":

          return false;
      }
    },

    showDestinationInput() {
      return this.selectedGroundAssignmentType === "Travel";
    },

    showCurrentTime() {
      const now = new Date().getTime();

      return (
        now > new Date(this.dateFilter.start).getTime() &&
        now < new Date(this.dateFilter.end).getTime()
      );
    },

    nowLineLeft() {
      const x = this.getLocationLeft(
        new Date().toISOString(),
        this.dateFilter.start,
        this.scale
      );

      if (x > 0 || x < this.boardWidth) {
        return x;
      } else {
        return 0;
      }
    },

    boardWidth() {
      return this.dateFilter.days.length * (1440 / this.scale) + 100;
    },

    dayWidth() {
      return 1440 / this.scale;
    },

    authorizedFlightRoles() {
      return this.$store.getters.authorizedFlightRoles;
    },

    companyOptions() {
      if (this.auth) {
        if (this.user.securityGroup.companies.length) {
          return [...this.user.securityGroup.companies];
        } else {
          return [];
        }
      } else {
        return [];
      }
    },

    jobTitleOptions() {
      if (this.auth) {
        if (this.user.securityGroup.jobTitles.length) {
          return [...this.user.securityGroup.jobTitles];
        } else {
          return [];
        }
      } else {
        return [];
      }
    },

    dateFilter() {
      return this.$store.state.dateFilter;
    },

    airports() {
      return this.$store.state.airports;
    },

    formatReservationConfirmed() {
      return this.groundAssignmentConfirmed ? "Confirmed" : "Not Confirmed";
    },

    showTimes() {
      // switch (this.selectedGroundAssignmentType) {
      //   case "Do Not Use":
      //   case "Floating Holiday":
      //   case  "Holiday":
      //   case "Layover":
      //   case "Leave - Bereavement":
      //   case "Leave - FMLA":
      //   case "Leave - Medical":
      //   case "Leave - Military":
      //   case "Leave - Non-FMLA":
      //   case "Leave - Parental":
      //   case "Leave - Personal":
      //   case "LOA - Jury Duty":
      //   case "LOA - Long Term Disability":
      //   case "LOA - Short Term Disability":
      //   case "LOA - Workers' Compensatio":
      //   case "Quarantine - Day OFF":
      //   case "Quarantine":
      //   case "Sick":
      //   case "Special Assignment":
      //   case "Stand By":
      //   case "Training - Ground School":
      //   case "Training - SIM":
      //   case "Travel":
      //   case "Vacation":
      //     return true;

      //   default:
      //     return false;
      // }

      switch (this.selectedGroundAssignmentType) {
        case "Do Not Use":
        case "Layover":
        case "Special Assignment":
        case "Training - Ground School":
        case "Training - SIM":
        case "Travel":
        case "Sick":
          return true;

        default:
          return false;
      }
    },

    showStation() {
      switch (this.selectedGroundAssignmentType) {
        case "Do Not Use":
        case "Layover":
        case "Quarantine - Day OFF":
        case "Quarantine":
        case "Sick":
        case "Special Assignment":
        case "Training - Ground School":
        case "Training - SIM":
        case "Travel":
          return true;

        default:
          return false;
      }
    },

    computedAssignmentShadow() {
      if (this.assignmentData) {
        let minutes;
        let width;

        switch (this.assignmentData.type) {
          case "Flight Assignment":
            minutes =
              (new Date(this.assignmentData.flight.effectiveTimeOut).getTime() -
                new Date(this.dateFilter.days[0]).getTime()) /
              1000 /
              60;

            width =
              (this.paddingBefore +
                this.assignmentData.flight.effectiveBlockTime +
                this.paddingAfter) /
              this.scale;

            break;

          case "Trip Assignment":
            minutes =
              (new Date(this.assignmentData.trip.startTime) -
                new Date(this.dateFilter.days[0]).getTime()) /
              1000 /
              60;

            width =
              (this.paddingBefore +
                this.assignmentData.trip.duration +
                this.paddingAfter) /
              this.scale;

            break;

          default:
            minutes =
              (new Date(this.assignmentData.stationAssignment.startTime) -
                new Date(this.dateFilter.days[0]).getTime()) /
              1000 /
              60;

            width =
              (this.paddingBefore +
                this.assignmentData.stationAssignment.duration +
                this.paddingAfter) /
              this.scale;
            break;
        }

        const left = (minutes - this.paddingBefore) / this.scale;

        let style = {
          width: `${width}px`,
          left: `${left}px`,
          height: "60px",
          borderLeft: "1px dashed blue",
          borderRight: "1px dashed blue",
          backgroundColor: "#a8a8f5b2",
          visibility: "visible",
          opacity: 0.5,
        };

        return style;
      } else {
        return {
          width: "1px",
          left: "1px",
          height: "1px",
          visibility: "hidden",
        };
      }
    },

    user() {
      return this.$store.state.user;
    },

    companyAssignmentToAssign() {
      return this.$store.getters.companyAssignmentToAssign;
    },

    selectedAssignments() {
      return this.assignmentsList.filter((assignment) => assignment.selected);
    },
  },
  methods: {
    async handleAdjustStationAssignments() {
      //---------------------------------------Refresh Token
      this.loading = true;
      const accessToken = await authentication.getAccessToken();
      if (!accessToken) {
        this.loading = false;
        this.$router.push({ name: "home" });
        return;
      }

      try {
        const res = await api.put(
          "/assignments/station/adjust",
          {
            dateFilterStart: this.dateFilter.start,
            dateFilterEnd: this.dateFilter.end,
          },
          {
            headers: {
              Authorization: "Bearer " + accessToken,
            },
          }
        );

        this.loading = false;

        if (res.status !== 200) {
          this.snackbarColor = "var(--red)";
          this.snackbarText = error.message.message
            ? error.message.message
            : error.message;
          this.snackbarVisible = true;
          return;
        }

        this.snackbarColor = "var(--blue)";
        this.snackbarText = `Checked: ${res.data.checked}\nNeeded Adjustments: ${res.data.needed}\nModified: ${res.data.modifiedCount}\nManager Notified: ${res.data.notified}\nDeleted: ${res.data.deletedCount}`;
        this.snackbarVisible = true;
        //Hide the snackbar after 3 seconds
        setTimeout(() => {
          this.snackbarVisible = false;
        }, 5000);

        this.getData();
      } catch (error) {
        this.loading = false;
        this.snackbarColor = "var(--red)";
        this.snackbarVisible = true;
        this.snackbarText = `Error adjusting station assignments`;
      }
    },
    updateStationAssignmentDuration() {
      const start = new Date(
        `${this.startDate}T${this.startTime}:00`
      ).getTime();
      const end = new Date(`${this.endDate}T${this.endTime}:00`).getTime();

      if (end > start) {
        this.stationAssignmentDuration = Math.floor((end - start) / 60000);
      } else {
        this.stationAssignmentDuration = 0;
      }
    },
    handleToggleSelectAll() {
      this.selectAll = !this.selectAll;

      this.assignmentsList.forEach((assignment) => {
        assignment.selected = this.selectAll;
      });
    },

    startInactivityTimer() {
      this.clearInactivityTimer();
      this.inactivityTimer = setTimeout(() => {
        this.handleAutoLogout();
      }, this.timeoutDuration);
    },

    clearInactivityTimer() {
      if (this.inactivityTimer) {
        clearTimeout(this.inactivityTimer);
      }
    },

    resetInactivityTimer() {
      this.startInactivityTimer();
    },

    async handleAutoLogout() {
      try {
        //---------------------------------------Refresh Token
        this.loading = true;
        const accessToken = await authentication.getAccessToken();
        if (!accessToken) {
          this.loading = false;
          return;
        }

        await api.get("/auth/logout", {
          headers: {
            Authorization: "Bearer " + accessToken,
          },
        });

        this.loading = false;

        this.$store.commit("updateAuth", null);
        this.$store.commit("updateUser", null);
        clearTimeout(this.inactivityTimer);
        this.$router.push({ name: "home" });
      } catch (error) {
        this.loading = false;
        this.snackbarColor = "var(--red)";
        this.snackbarVisible = true;
        this.snackbarText = `Error during auto-logout: ${error}`;

        setTimeout(() => {
          this.$store.commit("updateAuth", null);
          this.$store.commit("updateUser", null);
          clearTimeout(this.inactivityTimer);
        }, 3000);
      }
    },

    async getData() {
      this.employeesSchedule = [];
      this.filteredEmployeesSchedule = [];
      this.pages = [];
      this.page = null;

      //--------------------------Aircraft Deck Filter
      let aircraftDeck = "Cargo and Pax.";

      if (this.aircraftDeckFilter.active) {
        aircraftDeck = this.aircraftDeckFilter.deck.slice();
      }

      //--------------------------Company Filter
      let companyFilter = {
        active: false,
        name: "",
      };

      if (this.companyFilter.active) {
        companyFilter = {
          active: true,
          name: this.companyFilter.name.slice(),
        };
      }

      //--------------------------Job Title Filter
      let jobTitlesFilter = {
        active: false,
        jobTitles: [],
      };

      if (this.jobTitlesFilter.active) {
        jobTitlesFilter = {
          active: true,
          jobTitles: [...this.jobTitlesFilter.jobTitles],
        };
      }

      //---------------------------------------Refresh Token
      this.loading = true;
      const accessToken = await authentication.getAccessToken();
      if (!accessToken) {
        this.loading = false;
        this.$router.push({ name: "home" });
        return;
      }

      //const d1 = new Date();
      try {
        const res = await api.post(
          "/assignments/assignments",
          {
            dateFilterStart: this.dateFilter.start,
            dateFilterEnd: this.dateFilter.end,
            companyFilter,
            jobTitlesFilter,
            aircraftDeck,
          },
          {
            headers: {
              Authorization: "Bearer " + accessToken,
            },
          }
        );

        this.loading = false;

        if (res.status !== 200) {
          this.snackbarColor = "var(--red)";
          this.snackbarText = "Error fetching data";
          this.snackbarVisible = true;
          this.$store.commit("updateAssignmentBoardPageNumber", 0);
          return;
        }

        let employees = res.data.employees;

        const assignments = res.data.assignments;
        const biddays = res.data.biddays;

        let items = [];
        let employeeAssignments = [];

        employees.forEach((employee) => {
          employee.biddays = biddays.filter((bidday) => {
            return bidday.employee_id === employee._id;
          });

          employeeAssignments = assignments.filter((assignment) => {
            return assignment.employee?._id === employee._id;
          });

          if (!this.assignmentsAirportFilter.active) {
            items.push({
              employee,
              assignments: employeeAssignments,
            });
          } else {
            //Note: If filter by station is active
            // show only employees with assignments
            if (employeeAssignments.length) {
              let bingo = [];

              switch (this.assignmentsAirportFilter.match) {
                case "Departing":
                  bingo = employeeAssignments.filter((a) => {
                    return (
                      a.originIata === this.assignmentsAirportFilter.iataCode
                    );
                  });

                  break;
                case "Arriving":
                  bingo = employeeAssignments.filter((a) => {
                    return (
                      a.destinationIata ===
                      this.assignmentsAirportFilter.iataCode
                    );
                  });

                  break;

                default:
                  bingo = employeeAssignments.filter((a) => {
                    return (
                      a.originIata === this.assignmentsAirportFilter.iataCode ||
                      a.destinationIata ===
                        this.assignmentsAirportFilter.iataCode
                    );
                  });

                  break;
              }

              if (bingo.length) {
                items.push({
                  employee,
                  assignments: employeeAssignments,
                });
              }
            }
          }
        });

        this.employeesSchedule = items;

        this.filterEmployeesSchedule();
      } catch (error) {
        this.loading = false;
        this.snackbarColor = "var(--red)";
        this.snackbarText = error;
        this.snackbarVisible = true;
      }
    },

    getFilterByStationStyle() {
      let style = {
        color: "white",
      };

      if (this.filterByStation.active) {
        style.color = "#eab208";
      }

      return style;
    },

    filterEmployeesSchedule() {
      let filterOne = [];
      let filterTwo = [];
      this.totalEmployees = 0;

      if (this.search.length) {
        filterOne = this.employeesSchedule.filter((item) => {
          return (
            item.employee.surname
              .toUpperCase()
              .startsWith(this.search.toUpperCase()) ||
            item.employee.givenName
              .toUpperCase()
              .startsWith(this.search.toUpperCase())
          );
        });
      } else {
        filterOne = [...this.employeesSchedule];
      }

      //-----------------------Filter by Station

      if (this.filterByStation.active) {
        let count;
        let previousAssignments;
        let lastAssignment;

        filterTwo = filterOne.filter((employee) => {
          count = 0;

          if (employee.assignments.length) {
            previousAssignments = employee.assignments.filter((a) => {
              return (
                new Date(a.endTime).getTime() <= this.filterByStation.startTime
              );
            });

            previousAssignments.sort((a, b) =>
              a.endTime < b.endTime ? -1 : 1
            );

            if (previousAssignments.length) {
              lastAssignment =
                previousAssignments[previousAssignments.length - 1];
              if (
                lastAssignment.destinationIata ===
                this.filterByStation.originIata
              ) {
                count++;
              }
            }
          }
          return count > 0;
        });
      } else {
        filterTwo = [...filterOne];
      }

      this.selectAll = false;
      filterTwo.forEach((assignment) => {
        assignment.selected = false;
      });

      this.filteredEmployeesSchedule = [...filterTwo];

      this.paginate();

      this.assignmentsList = [];

      this.filteredEmployeesSchedule.forEach((item) => {
        item.assignments.forEach((assignment) => {
          this.assignmentsList.push({
            ...assignment,
            employee: item.employee,
          });
        });
      });

      this.totalEmployees = this.filteredEmployeesSchedule.length;
    },

    paginate() {
      this.pages = [];
      let _pages = [];
      this.page = null;

      if (this.filteredEmployeesSchedule.length) {
        let chunk = Math.min(
          Math.floor(this.availableBoardHeight / this.rowHeight),
          this.filteredEmployeesSchedule.length
        );

        //Show warning if not enough space to display
        if (chunk < 1) {
          this.snackbarColor = "var(--red)";
          this.snackbarText = "Not enough screen space to display data";
          this.snackbarVisible = true;
          return;
        }

        //Split data into pages
        for (let i = 0; i < this.filteredEmployeesSchedule.length; i += chunk) {
          let tempArray;
          tempArray = this.filteredEmployeesSchedule.slice(i, i + chunk);
          _pages.push({
            index: _pages.length,
            items: tempArray,
          });
        }

        this.pages = [..._pages];

        const i = this.pages.findIndex((page) => {
          return page.index === this.pageNumber;
        });

        if (i < 0) {
          this.$store.commit("updateAssignmentBoardPageNumber", 0);
        }

        this.page = this.pages[this.pageNumber];
      }
    },

    handleToggleStationFilter() {
      if (this.filterByStation.active) {
        this.filterByStation = {
          active: false,
          startTime: new Date(),
          originIata: "",
        };
      } else {
        let startTime;
        let originIata;

        switch (this.assignmentData.type) {
          case "Flight Assignment":
            startTime = new Date(
              this.assignmentData.flight.effectiveTimeOut
            ).getTime();
            originIata = this.assignmentData.flight.originIata.slice();

            break;

          case "Trip Assignment":
            startTime = new Date(this.assignmentData.trip.startTime);
            originIata = this.assignmentData.trip.flights[0].originIata.slice();

            break;

          default:
            startTime = new Date(
              this.assignmentData.stationAssignment.startTime
            );
            originIata =
              this.assignmentData.stationAssignment.originIata.slice();

            break;
        }

        this.filterByStation = {
          active: true,
          startTime,
          originIata,
        };
      }

      this.filterEmployeesSchedule();
      this.paginate();
    },

    getTripFlightRole(flight_id) {
      const role = this.tripRoles.get(flight_id);

      if (role) {
        return role;
      } else {
        return "Select Role";
      }
    },

    handleSetTripRole(flight_id) {
      this.tripRoles.set(flight_id, this.selectedRole);
    },

    getWarningStyle(level) {
      let style = {
        "background-color": "orange",
      };

      if (level === "Hard") {
        style = {
          "background-color": "pink",
        };
      }

      return style;
    },

    sortWarningsByKey(key) {
      const sortedAsc = this.isSortedAsc(this.filteredWarnings, key);

      if (sortedAsc) {
        this.filteredWarnings.sort((a, b) => (a[key] < b[key] ? 1 : -1));
      } else {
        this.filteredWarnings.sort((a, b) => (a[key] > b[key] ? 1 : -1));
      }
    },

    sortArrayByKey(key) {
      const sortedAsc = this.isSortedAsc(this.assignmentsList, key);

      if (sortedAsc) {
        this.assignmentsList.sort((a, b) => (a[key] < b[key] ? 1 : -1));
      } else {
        this.assignmentsList.sort((a, b) => (a[key] > b[key] ? 1 : -1));
      }
    },

    isSortedAsc(arr, key) {
      for (let i = 0; i < arr.length - 1; i++) {
        if (arr[i][key] > arr[i + 1][key]) {
          return false;
        }
      }
      return true;
    },

    getRowStyle(assignment) {
      const i = this.selectedAssignments.findIndex((item) => {
        return item._id === assignment._id;
      });

      if (i >= 0) {
        return {
          "background-color": "green",
          color: "gray",
        };
      } else {
        return {
          "background-color": "white",
          color: "black",
        };
      }
    },

    handleShowWarnings() {
      this.filteredWarnings = [...this.warnings];
      this.showWarningsDialog = true;
    },

    onResize() {
      const board = this.$refs.board;

      if (!board) return;

      this.availableBoardHeight = board.clientHeight - 120;

      this.itemsPerPage = Math.floor(
        this.availableBoardHeight / this.rowHeight
      );

      this.paginate();
    },

    handlePageUp() {
      if (this.pageNumber > 0) {
        const val = this.pageNumber - 1;
        this.$store.commit("updateAssignmentBoardPageNumber", val);
        this.page = this.pages[this.pageNumber];
      }
    },

    handlePageDown() {
      if (this.pageNumber < this.pages.length - 1) {
        const val = this.pageNumber + 1;
        this.$store.commit("updateAssignmentBoardPageNumber", val);
        this.page = this.pages[this.pageNumber];
      }
    },

    handleGoBack() {
      this.$router.push({ name: "flightBoard" });
    },

    handleNavigateToHome() {
      this.$router.push({ name: "home" });
    },

    async handleCloseAssignmentWarningsModal(acknowledged) {
      this.showAssigmentWarningsModal = false;

      if (acknowledged) {
        //---------------------------------------Refresh Token
        this.loading = true;
        const accessToken = await authentication.getAccessToken();
        if (!accessToken) {
          this.loading = false;
          this.$router.push({ name: "home" });
          return;
        }

        try {
          let res;

          switch (this.assignment.type) {
            case "Flight":
              const { flight } = this.assignmentData;
              if (this.assignmentData.assignmentToCover) {
                //Note this was assigned to a company

                res = await api.put(
                  `/flights/${flight._id}/crewmembers/cover`,
                  {
                    crewmember_id: this.assignmentData.assignmentToCover._id,
                    employee_id: this.employee._id,
                    warnings: [...this.assignmentWarnings],
                    remarks: this.remarks,
                  },
                  {
                    headers: {
                      Authorization: "Bearer " + accessToken,
                    },
                  }
                );
              } else {
                res = await api.put(
                  `/flights/${flight._id}/crewmembers/assign`,
                  {
                    employee_id: this.employee._id,
                    role: this.assignment.role,
                    remarks: this.assignment.remarks,
                    warnings: [...this.assignmentWarnings],
                  },
                  {
                    headers: {
                      Authorization: "Bearer " + accessToken,
                    },
                  }
                );
              }

              break;

            case "Trip":
              let assignments = [];

              this.assignment.assignments.forEach((item) => {
                assignments.push({
                  flight_id: item.flight._id,
                  role: item.role,
                  warnings: item.warnings,
                  remarks: this.remarks,
                });
              });

              res = await api.put(
                `/flights/crewmembers/trip/assign`,
                {
                  employee_id: this.employee._id,
                  assignments,
                  remarks: this.remarks,
                },
                {
                  headers: {
                    Authorization: "Bearer " + accessToken,
                  },
                }
              );

              break;

            case "Station Assignment":
              res = await api.put(
                `/assignments/station/assign`,
                {
                  ...this.assignment,
                },
                {
                  headers: {
                    Authorization: "Bearer " + accessToken,
                  },
                }
              );
              break;

            default:
              if (this.assignment._id) {
                res = await api.put(
                  `/assignments/${this.assignment._id}`,
                  {
                    ...this.assignment,
                  },
                  {
                    headers: {
                      Authorization: "Bearer " + accessToken,
                    },
                  }
                );
              } else {
                res = await api.post(
                  `/assignments`,
                  {
                    ...this.assignment,
                  },
                  {
                    headers: {
                      Authorization: "Bearer " + accessToken,
                    },
                  }
                );
              }

              break;
          }

          this.loading = false;
          this.assignment = null;

          if (res.status !== 200) {
            this.snackbarColor = "var(--red)";
            this.snackbarText = error.message.message
              ? error.message.message
              : error.message;
            this.snackbarVisible = true;
            return;
          }

          this.getData();
        } catch (error) {
          this.loading = false;
          this.snackbarColor = "var(--red)";
          this.snackbarText = error;
          this.snackbarVisible = true;
        }
      }
    },

    handleOpenFilters() {
      if (!this.selectedCompany) {
        this.selectedCompany = this.user.companyName.slice();
      }

      if (!this.selectedAircraftDeck) {
        this.selectedAircraftDeck = "Cargo Aircraft";
      }

      //------------------------------------------Airports Filter
      if (this.assignmentsAirportFilter.active) {
        this.filterByAirport = true;
        this.selectedIataCode = this.assignmentsAirportFilter.iataCode.slice();
      }

      //-----------------------------------------Aircraft Deck Filter
      if (this.aircraftDeckFilter.active) {
        this.filterByAircraftDeck = true;
        this.selectedAircraftDeck = this.aircraftDeckFilter.deck.slice();
      }

      //----------------------------------------Company Name Filter
      if (this.companyFilter.active) {
        this.filterByCompany = true;
        this.selectedCompany = this.companyFilter.name.slice();
      }

      //----------------------------------------Job Title Filter
      if (this.jobTitlesFilter.active) {
        this.filterByJobTitle = true;
        this.selectedJobTitles = [...this.jobTitlesFilter.jobTitles];
      } else {
        this.filterByJobTitle = false;
        this.selectedJobTitles = [];
      }

      this.showFiltersDialog = true;
    },

    handleSaveFilters() {
      this.showFiltersDialog = false;

      //------------------------------------Aircraft Deck Filter
      let aircraftDeckFilter = {
        active: false,
        deck: "",
      };

      if (this.filterByAircraftDeck) {
        aircraftDeckFilter = {
          active: true,
          deck: this.selectedAircraftDeck.slice(),
        };
      }

      this.$store.commit("updateAircraftDeckFilter", aircraftDeckFilter);

      //------------------------------------Airport Filter
      let assignmentsAirportFilter = {
        active: false,
        match: "",
        iataCode: "",
      };

      if (this.filterByAirport) {
        if (this.selectedIataCode?.length === 3) {
          const i = this.airports.findIndex((item) => {
            return item.iata === this.selectedIataCode.toUpperCase();
          });

          if (i >= 0) {
            assignmentsAirportFilter = {
              active: true,
              match: this.selectedIataMatch.slice(),
              iataCode: this.selectedIataCode.slice().toUpperCase(),
            };
          } else {
            this.filterByAirport = false;
            this.selectedIataCode = null;
          }
        } else {
          this.filterByAirport = false;
        }
      }

      this.$store.commit(
        "updateAssignmentsAirportFilter",
        assignmentsAirportFilter
      );

      //-----------------------------Company Filter
      let companyFilter = {
        active: false,
        name: "",
      };

      if (this.filterByCompany && this.selectedCompany) {
        companyFilter = {
          active: true,
          name: this.selectedCompany.slice(),
        };
      }

      this.$store.commit("updateCompanyFilter", companyFilter);

      //------------------------------Job Titles Filter
      let jobTitlesFilter = {
        active: false,
        jobTitles: [],
      };

      if (this.filterByJobTitle && this.selectedJobTitles.length) {
        jobTitlesFilter = {
          active: true,
          jobTitles: [...this.selectedJobTitles],
        };
      }

      this.$store.commit("updateJobTitlesFilter", jobTitlesFilter);

      this.getData();
    },

    handleShowFlightTooltip(assignment, index) {
      this.tooltip = { ...assignment };

      let style = {
        display: "block",
        top: `${index * this.rowHeight + 50 + 45}px`,
        left: `${
          this.getLocationLeft(
            assignment.startTime,
            this.dateFilter.days[0],
            this.scale
          ) + 30
        }px`,
      };

      if (this.pages.length > 1 && index >= this.page.items.length - 2) {
        style.top = `${index * this.rowHeight - 50}px`;
      } else {
        style.top = `${index * this.rowHeight + 50 + 45}px`;
      }

      this.tooltipStyle = style;
    },

    handleHideFlightTooltip() {
      setTimeout(() => {
        this.tooltipStyle = {
          display: "none",
        };
      }, 150);
    },

    handleNavigateToEmployeeProfile() {
      if (
        !this.user.securityGroup.keys.includes(107) &&
        !this.user.securityGroup.keys.includes(1106)
      ) {
        this.snackbarColor = "var(--red)";
        this.snackbarVisible = true;
        this.snackbarText = "Not authorized.Please contact your administrator.";
        return;
      }

      this.$router.push({
        name: "employeeUpdate",
        params: { id: this.employee._id },
      });
    },

    zoomIn() {
      if (this.scale > 1) {
        this.scale -= 1;
      }
    },

    zoomOut() {
      if (this.scale < 8) {
        this.scale += 1;
      }
    },

    handleToggleBoardStyle() {
      if (this.boardStyle === "Board") {
        this.boardStyle = "List";
      } else {
        this.boardStyle = "Board";
      }
    },

    handleRemoveTarget() {
      this.$store.commit("updateAssignmentData", null);
    },

    //-------------------------------------Filters and Settings
    handleOpenDateFilter(item) {
      this.startDate = item.substring(0, 10);
      this.numberOfDays = this.dateFilter.days.length;

      this.showDateFilterDialog = true;
    },

    handleSaveDateFilter() {
      const filterStart = new Date(this.startDate).getTime();

      this.showDateFilterDialog = false;

      //Pass filterStart in miliseconds, numberOfDays as integer
      this.$store.commit("updateDateFilter", {
        filterStart,
        numberOfDays: this.numberOfDays,
      });

      this.getData();
    },

    //--------------------------Employee Information
    handleShowEmployeeInformationDialog(employee) {
      if (this.user.securityGroup.keys.includes(106)) {
        this.employee = { ...employee };

        this.showEmployeeInformationDialog = true;
      }
    },

    handleAssignmentShadowClicked(item, e) {
      if (
        !this.user.securityGroup.keys.includes(21) &&
        !this.user.securityGroup.keys.includes(25)
      ) {
        this.snackbarColor = "var(--red)";
        this.snackbarText =
          "Not authorized. Please contact your administrator.";
        this.snackbarVisible = true;
        return;
      }

      this.employee = { ...item.employee, assignments: [...item.assignments] };

      e.stopPropagation();
      this.selectedRole = this.getSelectedRole();

      if (this.assignmentData.type === "Flight Assignment") {
        if (this.assignmentData.assignmentToCover) {
          //Note this was assigned to a company
          this.remarks = this.assignmentData.assignmentToCover.remarks
            ? this.assignmentData.assignmentToCover.remarks.slice()
            : null;
        }

        this.showNewFlightAssignmentDialog = true;
      } else if (this.assignmentData.type === "Trip Assignment") {
        this.showNewTripAssignmentDialog = true;
      } else if (this.assignmentData.type === "Station Assignment") {
        this.showNewStationAssignmentDialog = true;
      }
    },

    //--------------------------------------Flight Assignments
    getSelectedRole() {
      let i;
      let role;

      i = this.authorizedFlightRoles.findIndex((item) => {
        return item === this.employee.jobTitle;
      });

      if (i < 0) {
        i = this.authorizedFlightRoles.findIndex((item) => {
          return item === "Jumpseat";
        });
      }

      if (i >= 0) {
        role = this.authorizedFlightRoles[i].slice();
      } else {
        role = this.authorizedFlightRoles[0].slice();
      }

      return role;
    },

    async handleSaveFlightAssignment() {
      this.showNewFlightAssignmentDialog = false;

      this.assignmentWarnings = this.getFlightAssignmentWarnings(
        this.employee,
        this.assignmentData.flight,
        this.selectedRole
      );

      const { flight } = this.assignmentData;

      let assignment = {
        type: "Flight",
        flight_id: flight._id,
        startTime: flight.effectiveTimeOut,
        endTime: flight.effectiveTimeIn,
        originIata: flight.originIata,
        destinationIata: flight.destinationIata,
        employee_id: this.employee._id,
        role: this.selectedRole,
        warnings: [...this.assignmentWarnings],
        remarks: this.remarks,
      };

      if (this.assignmentData.assignmentToCover) {
        //Note this was assigned to a company
        assignment.crewmember_id = this.assignmentData.assignmentToCover._id;
      }

      if (this.assignmentWarnings.length) {
        this.assignment = assignment;
        this.showAssigmentWarningsModal = true;
        return;
      }

      let res;

      //---------------------------------------Refresh Token
      this.loading = true;
      const accessToken = await authentication.getAccessToken();
      if (!accessToken) {
        this.loading = false;
        this.$router.push({ name: "home" });
        return;
      }

      if (this.assignmentData.assignmentToCover) {
        res = await api.put(
          `/flights/${flight._id}/crewmembers/cover`,
          {
            crewmember_id: this.assignmentData.assignmentToCover._id,
            employee_id: this.employee._id,
            warnings: [...this.assignmentWarnings],
            remarks: this.remarks,
          },
          {
            headers: {
              Authorization: "Bearer " + accessToken,
            },
          }
        );
      } else {
        res = await api.put(
          `/flights/${flight._id}/crewmembers/assign`,
          {
            employee_id: this.employee._id,
            assignedToCompany: this.selectedAssignedToCompany,
            role: this.selectedRole,
            warnings: [...this.assignmentWarnings],
            remarks: this.remarks,
          },
          {
            headers: {
              Authorization: "Bearer " + accessToken,
            },
          }
        );
      }

      this.loading = false;

      if (res.status !== 200) {
        this.snackbarColor = "var(--red)";
        this.snackbarText = error.message.message
          ? error.message.message
          : error.message;
        this.snackbarVisible = true;
        return;
      }

      this.getData();
    },

    handleShowFlightAssignmentInformationDialog(flightAssignment, e) {
      e.stopPropagation();

      this.flightAssignment = {
        ...flightAssignment,
      };

      this.showFlightAssignmentInformationDialog = true;
    },

    async hideFlightAssignmentInformationDialog(e) {
      this.showFlightAssignmentInformationDialog = false;
      this.flightAssignment = null;

      if (e.action === "refresh") {
        this.getData();
      }
    },

    //------------------------------------------Assignments (Shared)
    async handleDeleteAssignments() {
      let crewmembers = [];
      let stationAssignment_ids = [];
      let otherAssignment_ids = [];

      this.selectedAssignments.forEach((item) => {
        if (item.type === "Flight") {
          crewmembers.push({
            flight_id: item.flight_id,
            crewmember_id: item._id,
          });
        } else if (item.type === "Station") {
          stationAssignment_ids.push(item._id);
        } else {
          otherAssignment_ids.push(item._id);
        }
      });

      //---------------------------------------Refresh Token
      this.loading = true;
      const accessToken = await authentication.getAccessToken();
      if (!accessToken) {
        this.loading = false;
        this.$router.push({ name: "home" });
        return;
      }

      try {
        const res = await api.delete(`/assignments`, {
          headers: {
            Authorization: "Bearer " + accessToken,
          },
          data: {
            crewmembers,
            stationAssignment_ids,
            otherAssignment_ids,
          },
        });

        this.loading = false;

        if (res.status !== 200) {
          this.snackbarColor = "var(--red)";
          this.snackbarText = error.message.message
            ? error.message.message
            : error.message;
          this.snackbarVisible = true;
          return;
        }

        this.getData();
        this.boardStyle = "Board";
      } catch (error) {
        this.loading = false;
        this.snackbarColor = "var(--red)";
        this.snackbarText = error;
        this.snackbarVisible = true;
      }
    },

    //--------------------------------------Trip Assignments
    // handleStartNewTripAssignment() {
    //   this.selectedRole = this.getSelectedRole();

    //   this.showNewTripAssignmentDialog = true;
    // },

    async handleSaveTripAssignment() {
      this.showNewTripAssignmentDialog = false;

      let assignmentsMap = new Map();
      let flight;
      let warnings = [];
      this.assignmentWarnings = [];

      for (let i = 0; i < this.assignmentData.trip.flights.length; i++) {
        flight = this.assignmentData.trip.flights[i];

        let role = this.tripRoles.get(flight._id);

        if (!role) {
          role = this.selectedRole.slice();
        }

        warnings = this.getFlightAssignmentWarnings(
          this.employee,
          flight,
          role
        );

        // Add only the first route discontiunity if applicable
        if (i > 0) {
          warnings = warnings.filter((element) => {
            return element.type !== "Route Discontinuity";
          });
        }

        if (warnings.length) {
          for (let index = 0; index < warnings.length; index++) {
            const item = warnings[index];

            const x = this.assignmentWarnings.findIndex((warning) => {
              return warning.message === item.message;
            });

            if (x < 0) {
              this.assignmentWarnings.push(item);
            }
          }
        }

        assignmentsMap.set(flight._id, {
          flight,
          warnings,
          role,
        });
      }

      this.assignment = {
        type: "Trip",
        assignments: Array.from(assignmentsMap.values()),
      };

      if (this.assignmentWarnings.length) {
        this.showNewTripAssignmentDialog = false;
        this.showAssigmentWarningsModal = true;
        return;
      }

      //---------------------------------------Refresh Token
      this.loading = true;
      const accessToken = await authentication.getAccessToken();
      if (!accessToken) {
        this.loading = false;
        this.$router.push({ name: "home" });
        return;
      }

      try {
        let assignments = [];

        this.assignment.assignments.forEach((item) => {
          assignments.push({
            flight_id: item.flight._id,
            role: item.role,
            warnings: item.warnings,
            remarks: this.remarks,
          });
        });

        const res = await api.put(
          `/flights/crewmembers/trip/assign`,
          {
            employee_id: this.employee._id,
            remarks: this.remarks,
            assignments,
          },
          {
            headers: {
              Authorization: "Bearer " + accessToken,
            },
          }
        );

        this.assignment = null;
        this.loading = false;

        if (res.status !== 200) {
          this.snackbarColor = "var(--red)";
          this.snackbarText = error.message.message
            ? error.message.message
            : error.message;
          this.snackbarVisible = true;
          return;
        }

        this.getData();
      } catch (error) {
        this.loading = false;
        this.snackbarColor = "var(--red)";
        this.snackbarText = error;
        this.snackbarVisible = true;
      }
    },

    //-----------------------Ground Assignments
    handleStartNewGroundAssignment(item, e) {
      if (!this.user.securityGroup.keys.includes(112)) {
        this.snackbarColor = "var(--red)";
        this.snackbarText =
          "Not authorized. Please contact your administrator.";
        this.snackbarVisible = true;
        return;
      }

      this.employee = {
        ...item.employee,
        assignments: [...item.assignments],
      };

      // Assuming you have a ref named "scrollContainer" for the scrollable container
      const scrollContainer = this.$refs.scrollContainer;

      // Calculate the x position relative to the scrollable container
      const x =
        e.clientX -
        scrollContainer.getBoundingClientRect().left +
        scrollContainer.scrollLeft;

      const minutes = x * this.scale;

      const startDateTime = new Date(
        new Date(this.dateFilter.start).getTime() + minutes * 60 * 1000
      ).toISOString();

      const endDateTime = new Date(
        new Date(this.dateFilter.start).getTime() +
          minutes * 60 * 1000 +
          8 * 60 * 60 * 1000 //Add 8 hours to start time
      ).toISOString();

      this.groundAssignmentStartDate = startDateTime.substring(0, 10);
      this.groundAssignmentStartTime = startDateTime.substring(11, 16);

      this.groundAssignmentEndDate = endDateTime.substring(0, 10);
      this.groundAssignmentEndTime = endDateTime.substring(11, 16);

      this.selectedGroundAssignmentType = this.groundAssignmentTypes[0];

      this.groundAssignment = null;
      this.grounAssignmentDestination = null;
      this.grounAssignmentRemarks = null;

      this.showNewGroundAssignmentDialog = true;
    },

    async handleSaveGroundAssignment() {
      let d1;
      let d2;

      this.groundAssignmentOrigin = null;
      this.groundAssignmentDestination = null;

      switch (this.selectedGroundAssignmentType) {
        case "Special Assignment":
        case "Layover":
        case "Training - Ground School":
        case "Training - SIM":
        case "Do Not Use":
          //Check Origin IATA
          this.groundAssignmentOrigin = this.airports.find((airport) => {
            return (
              airport.iata === this.groundAssignmentOriginIata.toUpperCase()
            );
          });

          if (!this.groundAssignmentOrigin) {
            this.snackbarColor = "var(--red)";
            this.snackbarText = `We couln't find an airport with IATA code ${this.groundAssignmentOriginIata.toUpperCase()}`;
            this.snackbarVisible = true;
            this.loading = false;
            this.readOnly = true;
            return;
          }

          //Make Destination equal to origin
          this.groundAssignmentDestination = { ...this.groundAssignmentOrigin };

          d1 = `${this.groundAssignmentStartDate}T${this.groundAssignmentStartTime}:00.000+00:00`;
          d2 = `${this.groundAssignmentEndDate}T${this.groundAssignmentEndTime}:59.999+00:00`;

          break;
        case "Stand By":
          //Check Origin IATA
          this.groundAssignmentOrigin = this.airports.find((airport) => {
            return airport.iata === this.employee.gatewayCode;
          });

          if (!this.groundAssignmentOrigin) {
            this.snackbarColor = "var(--red)";
            this.snackbarText = `We couln't find an airport with IATA code ${this.groundAssignmentOriginIata.toUpperCase()}`;
            this.snackbarVisible = true;
            this.loading = false;
            this.readOnly = true;
            return;
          }

          //Make Destination equal to origin
          this.groundAssignmentDestination = { ...this.groundAssignmentOrigin };

          d1 = `${this.groundAssignmentStartDate}T00:00:00.000+00:00`;
          d2 = `${this.groundAssignmentEndDate}T23:59:59.999+00:00`;

          break;
        case "Quarantine":
        case "Quarantine - Day OFF":
          //Check Origin IATA
          this.groundAssignmentOrigin = this.airports.find((airport) => {
            return (
              airport.iata === this.groundAssignmentOriginIata.toUpperCase()
            );
          });

          if (!this.groundAssignmentOrigin) {
            this.snackbarColor = "var(--red)";
            this.snackbarText = `We couln't find an airport with IATA code ${this.groundAssignmentOriginIata.toUpperCase()}`;
            this.snackbarVisible = true;
            this.loading = false;
            this.readOnly = true;
            return;
          }

          //Make Destination equal to origin
          this.groundAssignmentDestination = { ...this.groundAssignmentOrigin };

          d1 = `${this.groundAssignmentStartDate}T00:00:00.000+00:00`;
          d2 = `${this.groundAssignmentEndDate}T23:59:59.999+00:00`;
          break;
        case "Travel":
          //Check Origin IATA
          this.groundAssignmentOrigin = this.airports.find((airport) => {
            return (
              airport.iata === this.groundAssignmentOriginIata.toUpperCase()
            );
          });

          if (!this.groundAssignmentOrigin) {
            this.snackbarColor = "var(--red)";
            this.snackbarText = `We couln't find an airport with IATA code ${this.groundAssignmentOriginIata.toUpperCase()}`;
            this.snackbarVisible = true;
            this.loading = false;
            this.readOnly = true;
            return;
          }

          //Check Destination IATA
          this.groundAssignmentDestination = this.airports.find((airport) => {
            return (
              airport.iata ===
              this.groundAssignmentDestinationIata.toUpperCase()
            );
          });

          if (!this.groundAssignmentDestination) {
            this.snackbarColor = "var(--red)";
            this.snackbarText = `We couln't find an airport with IATA code ${this.groundAssignmentDestinationIata.toUpperCase()}`;
            this.snackbarVisible = true;
            this.loading = false;
            this.readOnly = true;
            return;
          }

          d1 = `${this.groundAssignmentStartDate}T${this.groundAssignmentStartTime}:00.000+00:00`;
          d2 = `${this.groundAssignmentEndDate}T${this.groundAssignmentEndTime}:59.999+00:00`;
          break;
        case "Sick":
          //Check Origin IATA
          this.groundAssignmentOrigin = this.airports.find((airport) => {
            return (
              airport.iata === this.groundAssignmentOriginIata.toUpperCase()
            );
          });

          if (!this.groundAssignmentOrigin) {
            this.snackbarColor = "var(--red)";
            this.snackbarText = `We couln't find an airport with IATA code ${this.groundAssignmentOriginIata.toUpperCase()}`;
            this.snackbarVisible = true;
            this.loading = false;
            this.readOnly = true;
            return;
          }

          //Make Destination equal to origin
          this.groundAssignmentDestination = { ...this.groundAssignmentOrigin };

          d1 = `${this.groundAssignmentStartDate}T${this.groundAssignmentStartTime}:00.000+00:00`;
          d2 = `${this.groundAssignmentEndDate}T${this.groundAssignmentEndTime}:59.999+00:00`;
          break;
        default:
          // case "Vacation":
          // case "Holiday":
          // case "LOA - Jury Duty":
          // case "LOA - Long Term Disability":
          // case "LOA - Short Term Disability":
          // case "LOA - Workers' Compensation":
          // case "Floating Holiday":
          // case "Leave - Bereavement":
          // case "Leave - FMLA":
          // case "Leave - Medical":
          // case "Leave - Military":
          // case "Leave - Non-FMLA":
          // case "Leave - Parental":
          // case "Leave - Personal":

          //Check Origin IATA
          this.groundAssignmentOrigin = this.airports.find((airport) => {
            return airport.iata === this.employee.gatewayCode;
          });

          if (!this.groundAssignmentOrigin) {
            this.snackbarColor = "var(--red)";
            this.snackbarText = `We couln't find an airport with IATA code ${this.employee.gatewayCode.toUpperCase()}. Please check employee's Gateway.`;
            this.snackbarVisible = true;
            this.loading = false;
            this.readOnly = true;
            return;
          }

          //Make Destination equal to origin
          this.groundAssignmentDestination = { ...this.groundAssignmentOrigin };
          d1 = `${this.groundAssignmentStartDate}T00:00:00.000+00:00`;
          d2 = `${this.groundAssignmentEndDate}T23:59:59.999+00:00`;

          break;
      }

      this.groundAssignmentStartDateTime = new Date(d1);
      this.groundAssignmentEndDateTime = new Date(d2);

      this.groundAssignmentDuration = Math.ceil(
        (this.groundAssignmentEndDateTime.getTime() -
          this.groundAssignmentStartDateTime.getTime()) /
          60 /
          1000
      );

      if (
        this.groundAssignmentDuration <= this.groundAssignmentMinimumDuration
      ) {
        this.snackbarColor = "var(--red)";
        this.snackbarText = `The minimum duration for a ground assignment is ${this.groundAssignmentMinimumDuration} minutes`;
        this.snackbarVisible = true;
        this.loading = false;
        this.readOnly = true;
        return;
      }

      if (this.selectedGroundAssignmentType === "Travel") {
        if (this.groundAssignmentDuration > 1 * 24 * 60) {
          this.snackbarColor = "var(--red)";
          this.snackbarText = `The maximum duration for a travel assignment is 1 day`;
          this.snackbarVisible = true;
          this.loading = false;
          this.readOnly = true;
          return;
        }
      } else {
        if (this.groundAssignmentDuration > 31 * 24 * 60) {
          this.snackbarColor = "var(--red)";
          this.snackbarText = `The maximum duration for a ground assignment is 31 days`;
          this.snackbarVisible = true;
          this.loading = false;
          this.readOnly = true;
          return;
        }
      }

      this.showNewGroundAssignmentDialog = false;

      let assignment = {
        type: this.selectedGroundAssignmentType,
        startTime: this.groundAssignmentStartDateTime,
        endTime: this.groundAssignmentEndDateTime,
        duration: this.groundAssignmentDuration,
        originIata: this.groundAssignmentOrigin.iata,
        destinationIata: this.groundAssignmentDestination.iata,
        originCountry: this.groundAssignmentOrigin.country,
        destinationCountry: this.groundAssignmentDestination.country,
        confirmed: this.groundAssignmentConfirmed,
        employee_id: this.employee._id,
        remarks: this.remarks,
      };

      this.assignmentWarnings = this.getGroundAssignmentWarnings(
        this.employee,
        assignment
      );

      assignment.warnings = [...this.assignmentWarnings];

      if (this.assignmentWarnings.length) {
        this.assignment = assignment;
        this.showAssigmentWarningsModal = true;
        return;
      }

      //---------------------------------------Refresh Token
      this.loading = true;
      const accessToken = await authentication.getAccessToken();
      if (!accessToken) {
        this.loading = false;
        this.$router.push({ name: "home" });
        return;
      }

      try {
        const res = await api.post(
          `/assignments`,
          {
            ...assignment,
          },
          {
            headers: {
              Authorization: "Bearer " + accessToken,
            },
          }
        );

        this.loading = false;

        if (res.status !== 200) {
          this.snackbarColor = "var(--red)";
          this.snackbarText = error.message.message
            ? error.message.message
            : error.message;
          this.snackbarVisible = true;
          return;
        }

        this.remarks = null;
        this.getData();
      } catch (error) {
        this.loading = false;
        this.snackbarColor = "var(--red)";
        this.snackbarText = error;
        this.snackbarVisible = true;
      }
    },

    async handleShowGroundAssignmentInformationDialog(
      item,
      groundAssignment,
      e
    ) {
      e.stopPropagation();

      this.employee = {
        ...item.employee,
        assignments: [...item.assignments],
      };
      this.groundAssignment = {
        ...groundAssignment,
      };

      this.showGroundAssignmentInformationDialog = true;
    },

    async handleShowAssignmentInformationDialogFromWarning(warning) {
      this.showWarningsDialog = false;

      const { employee, assignment } = warning;

      this.employee = {
        ...employee,
      };

      switch (assignment.type) {
        case "Station Assignment":
          try {
            //---------------------------------------Refresh Token
            this.loading = true;
            const accessToken = await authentication.getAccessToken();
            if (!accessToken) {
              this.loading = false;
              this.$router.push({ name: "home" });
              return;
            }

            const { originIata } = assignment;

            const res = await api.get(
              `/assignments/station/get-flights/${assignment._id}`,
              {
                headers: {
                  Authorization: "Bearer " + accessToken,
                },
              }
            );

            this.loading = false;

            if (res.status !== 200) {
              this.snackbarColor = "var(--red)";
              this.snackbarText = error.message.message
                ? error.message.message
                : error.message;
              this.snackbarVisible = true;
              return;
            }

            const flights = res.data.flights;

            let processedFlights = [];

            flights.forEach((flight) => {
              if (flight.originIata === originIata) {
                processedFlights.push({
                  ...flight,
                  type: "Kick-out",
                  startTime:
                    new Date(flight.effectiveTimeOut).getTime() -
                    3 * 60 * 60 * 1000,
                  endTime:
                    new Date(flight.effectiveTimeOut).getTime() +
                    1 * 60 * 60 * 1000,
                });
              } else {
                processedFlights.push({
                  ...flight,
                  type: "Arrival",
                  startTime:
                    new Date(flight.effectiveTimeIn).getTime() -
                    1 * 60 * 60 * 1000,
                  endTime:
                    new Date(flight.effectiveTimeIn).getTime() +
                    1 * 60 * 60 * 1000,
                });
              }
            });

            // 1. Sort by UTC start time
            const sortedFlights = processedFlights
              .slice()
              .sort((a, b) => new Date(a.startTime) - new Date(b.startTime));

            this.stationAssignment = {
              ...assignment,
              flights: sortedFlights,
            };
            this.showStationAssignmentInformationDialog = true;
          } catch (error) {
            this.snackbarColor = "var(--red)";
            this.snackbarText = error.message.message
              ? error.message.message
              : error.message;
            this.snackbarVisible = true;
            return;
          }
          break;
        case "Flight":
          this.flightAssignment = {
            ...assignment,
          };

          this.showFlightAssignmentInformationDialog = true;
          break;
        default:
          this.employee = {
            ...employee,
          };
          this.groundAssignment = {
            ...assignment,
          };

          this.showGroundAssignmentInformationDialog = true;

          break;
      }
    },

    async handleUpdateGroundAssignment(e) {
      this.showGroundAssignmentInformationDialog = false;

      const assignment = e.assignment;

      const warnings = this.getGroundAssignmentWarnings(
        this.employee,
        assignment
      );

      assignment.warnings = warnings;

      if (assignment.warnings.length) {
        this.assignment = assignment;
        this.showAssigmentWarningsModal = true;
        return;
      }

      //---------------------------------------Refresh Token
      this.loading = true;
      const accessToken = await authentication.getAccessToken();
      if (!accessToken) {
        this.loading = false;
        this.$router.push({ name: "home" });
        return;
      }

      try {
        const res = await api.put(
          `/assignments/${assignment._id}`,
          {
            ...assignment,
          },
          {
            headers: {
              Authorization: "Bearer " + accessToken,
            },
          }
        );

        this.assignment = null;
        this.employee = null;
        this.loading = false;

        if (res.status !== 200) {
          this.snackbarColor = "var(--red)";
          this.snackbarText = error.message.message
            ? error.message.message
            : error.message;
          this.snackbarVisible = true;
          return;
        }

        this.getData();
      } catch (error) {
        this.loading = false;
        this.snackbarColor = "var(--red)";
        this.snackbarText = error;
        this.snackbarVisible = true;
      }
    },

    handleCloseGroundAssignmentInformationDialog(refreshData) {
      this.showGroundAssignmentInformationDialog = false;
      this.groundAssignment = null;
      if (refreshData) {
        this.getData();
      }
    },

    //-----------------------Station Assignments
    async handleShowStationAssignmentInformationDialog(assignment, e) {
      e.stopPropagation();

      //---------------------------------------Refresh Token
      this.loading = true;
      const accessToken = await authentication.getAccessToken();
      if (!accessToken) {
        this.loading = false;
        this.$router.push({ name: "home" });
        return;
      }

      const { originIata, _id } = assignment;

      try {
        const res = await api.get(`/assignments/station/get-flights/${_id}`, {
          headers: {
            Authorization: "Bearer " + accessToken,
          },
        });

        this.loading = false;

        if (res.status !== 200) {
          this.snackbarColor = "var(--red)";
          this.snackbarText = error.message.message
            ? error.message.message
            : error.message;
          this.snackbarVisible = true;
          return;
        }

        const flights = res.data.flights;

        let processedFlights = [];

        flights.forEach((flight) => {
          if (flight.originIata === originIata) {
            processedFlights.push({
              ...flight,
              type: "Kick-out",
              startTime:
                new Date(flight.effectiveTimeOut).getTime() -
                3 * 60 * 60 * 1000,
              endTime:
                new Date(flight.effectiveTimeOut).getTime() +
                1 * 60 * 60 * 1000,
            });
          } else {
            processedFlights.push({
              ...flight,
              type: "Arrival",
              startTime:
                new Date(flight.effectiveTimeIn).getTime() - 1 * 60 * 60 * 1000,
              endTime:
                new Date(flight.effectiveTimeIn).getTime() + 1 * 60 * 60 * 1000,
            });
          }
        });

        // 1. Sort by UTC start time
        const sortedFlights = processedFlights
          .slice()
          .sort((a, b) => new Date(a.startTime) - new Date(b.startTime));

        this.stationAssignment = {
          ...assignment,
          flights: sortedFlights,
        };

        this.showStationAssignmentInformationDialog = true;
      } catch (error) {
        this.loading = false;
        this.snackbarColor = "var(--red)";
        this.snackbarText = error;
        this.snackbarVisible = true;
      }
    },

    hideStationAssignmentInformationDialog(refreshData) {
      this.showStationAssignmentInformationDialog = false;
      this.stationAssignment = null;
      if (refreshData) {
        this.getData();
      }
    },

    async handleSaveStationAssignment() {
      this.warningText = null;

      const assignmentStart = new Date(
        `${this.startDate}T${this.startTime}:00.000+00:00`
      ).getTime();

      const assignmentEnd = new Date(
        `${this.endDate}T${this.endTime}:00.000+00:00`
      ).getTime();

      const result = this.validateStationAssignmentCoverPeriod(
        this.assignmentData.stationAssignment.flights,
        this.assignmentData.stationAssignment.originIata
      );

      if (!result.valid) {
        this.warningText = result.message;
        return;
      }

      // The proposed assignment start time cannnot be later than the computed valid start time
      // The proposed assignment end time cannot be earlier than the computed valid end time

      if (
        assignmentStart > result.startTime ||
        assignmentEnd < result.endTime
      ) {
        this.warningText = `Based on the assigned flights, the valid assignment cover period starts on ${this.formatDateTime(
          new Date(result.startTime)
        )} and ends on ${this.formatDateTime(
          new Date(result.endTime)
        )}. The proposed assignment cover period must be within this range. You can start before or on the valid start time and end on or after the valid end time.`;

        return;
      }

      const duration = Math.floor((assignmentEnd - assignmentStart) / 60000);

      if (duration < 30) {
        this.warningText =
          "The minimum duration for a station assignment is 30 minutes";
        return;
      }

      if (duration > 30 * 60) {
        this.warningText =
          "The maximum duration for a station assignment is 30 hours";
        return;
      }

      this.showNewStationAssignmentDialog = false;

      // let flightIds = [];
      // this.assignmentData.stationAssignment.flights.forEach((flight) => {
      //   flightIds.push(flight.flightId);
      // });

      const flightIds = this.assignmentData.stationAssignment.flights.map(
        (flight) => flight.flightId
      );

      let assignment = {
        type: "Station Assignment",
        employee_id: this.employee._id,
        assignedToCompany: null,
        startTime: new Date(assignmentStart),
        endTime: new Date(assignmentEnd),
        originIata: this.assignmentData.stationAssignment.originIata,
        destinationIata: this.assignmentData.stationAssignment.originIata,
        duration,
        role: this.selectedRole,
        flightIds,
        remarks: this.remarks,
      };

      this.assignmentWarnings = this.getStationAssignmentWarnings(
        this.employee,
        this.assignmentData.stationAssignment.flights,
        assignment
      );

      assignment.warnings = [...this.assignmentWarnings];

      if (assignment.warnings.length) {
        this.assignment = assignment;
        this.showStationAssignmentInformationDialog = false;
        this.showAssigmentWarningsModal = true;
        return;
      }

      //---------------------------------------Refresh Token
      this.loading = true;
      const accessToken = await authentication.getAccessToken();
      if (!accessToken) {
        this.loading = false;
        this.$router.push({ name: "home" });
        return;
      }
      const res = await api.put(
        `/assignments/station/assign`,
        {
          ...assignment,
        },
        {
          headers: {
            Authorization: "Bearer " + accessToken,
          },
        }
      );

      this.loading = false;

      if (res.status !== 200) {
        this.snackbarColor = "var(--red)";
        this.snackbarText = error.message.message
          ? error.message.message
          : error.message;
        this.snackbarVisible = true;
        return;
      }

      this.getData();
    },

    handleGetCalculatedCoverPeriod() {
      this.warningText = null;

      const result = this.validateStationAssignmentCoverPeriod(
        this.assignmentData.stationAssignment.flights,
        this.assignmentData.stationAssignment.originIata
      );

      if (!result.valid) {
        this.warningText = result.message;
        return;
      }

      this.startDate = new Date(result.startTime)
        .toISOString()
        .substring(0, 10);
      this.startTime = new Date(result.startTime)
        .toISOString()
        .substring(11, 16);
      this.endDate = new Date(result.endTime).toISOString().substring(0, 10);
      this.endTime = new Date(result.endTime).toISOString().substring(11, 16);
    },

    //------------------------Formatters and Stylers

    formatDate(miliseconds) {
      return new Date(miliseconds).toISOString().substring(0, 10);
    },

    formatDateShort(miliseconds) {
      const date = new Date(miliseconds);

      let options = {
        timeZone: "UTC",
        month: "short",
        day: "numeric",
      };

      return new Intl.DateTimeFormat("en-US", options).format(date);
    },

    formatTime(miliseconds) {
      return new Date(miliseconds).toISOString().substring(11, 16);
    },

    formatDateTime(dateTimeString) {
      const date = new Date(dateTimeString);

      let options = {
        timeZone: "UTC",
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        hourCycle: "h23",
      };

      return new Intl.DateTimeFormat("en-US", options).format(date);
    },

    formatAssignment(assignment) {
      const timeOut = this.formatDateTime(assignment.startTime);
      const timeIn = this.formatDateTime(assignment.endTime);

      switch (assignment.type) {
        case "Flight":
          return `${assignment.role} . ${assignment.flightNumber} . ${assignment.aircraftRegistration} . ${assignment.originIata} - ${assignment.destinationIata} . ${timeOut} Z - ${timeIn} Z`;

        case "Travel":
          return `${assignment.type} . ${assignment.originIata} - ${assignment.destinationIata} . ${timeOut} Z - ${timeIn} Z`;
        case "Station":
          return `Station Assignment . ${assignment.originIata} . ${timeOut} Z - ${timeIn} Z`;

        default:
          return `${assignment.type} . ${assignment.originIata} . ${timeOut} Z - ${timeIn} Z`;
      }
    },

    formatHeaderDate(string) {
      const date = new Date(string);

      let options = {
        timeZone: "UTC",
        year: "numeric",
        month: "short",
        day: "numeric",
        weekday: "long",
      };

      return new Intl.DateTimeFormat("en-US", options).format(date);
    },

    getBidDayStyle(bidDay) {
      //Default color "DO" - Day Off
      let backgroundColor = "#E74C3C";

      switch (bidDay.code) {
        case "RES":
          backgroundColor = "#2ECC71";
          break;
        case "VAC":
          backgroundColor = "#A569BD";
          break;
        default:
          break;
      }

      const x =
        (new Date(Date.UTC(bidDay.year, bidDay.month, bidDay.day)).getTime() -
          new Date(this.dateFilter.days[0]).getTime()) /
        1000 /
        60 /
        this.scale;

      const style = {
        top: 0,
        left: `${x}px`,
        height: `${this.rowHeight}px`,
        width: `${this.dayWidth}px`,
        backgroundColor,
      };

      return style;
    },
  },
};
</script>

<style scoped>
.flight-tooltip {
  position: absolute;
  top: 0;
  left: 0;
  display: none;
  min-width: 250px;
  padding: 5px;
  border-radius: 3px;
  background-color: rgba(128, 128, 128, 0.9);
  color: #fff;
  -webkit-user-select: none;
  user-select: none;
  z-index: 700;
}

.right-panel-row {
  position: absolute;
  top: 50px;
  left: 0;
  height: 0;
  width: 0;
  border-bottom: 1px solid gray;
  background-color: white;
  overflow: hidden;
}

.right-panel-row:nth-child(odd) {
  background-color: rgb(236, 225, 225);
}

section {
  padding: 0 1rem;
  min-height: 10rem;
  max-height: 26rem;
  overflow-y: auto;
}

.warning-tile {
  border: 1px solid gray;
  border-radius: 5px;
  padding: 5px 10px;
  color: black;
  margin-bottom: 3px;
}
</style>
